// Structured content and SEO data from MC Transport JSON
export const SEO_PAGES_DATA = [
  {
    page_id: "4122fd0c-04c4-497b-a3c3-4051e78ae9f4",
    url_path: "/",
    badge: "Kernekompetence · Hele Danmark",
    heroImage: "/_assets/scania-autotransporter-ugerloese.png",
    seo: {
      title_tag: "Autotransport i hele Danmark | MC Transport",
      meta_description: "Få professionel autotransport i hele Danmark hos MC Transport. Vi hjælper med autohjælp, bugsering og bjærgning døgnet rundt, få et tilbud til din opgave."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Autotransport og autohjælp i hele Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Hos MC Transport er autotransport vores centrale opgave. Vi flytter nye, brugte, skadede og brændte biler for både private og virksomheder. Uanset om du skal have én bil eller flere køretøjer flyttet, løser vi autotransport i hele Danmark med materiel, der vælges efter opgaven."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Har du brug for autotransport af én bil eller flere"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vi råder over skydeladsbiler, kranbiler og transportere med plads til flere biler. Det giver os mulighed for at håndtere både køreklare biler og køretøjer, som kræver særlig læsning. Læs mere om vores autotransport og det materiel, vi bruger til forskellige transportopgaver."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen på autotransport afhænger blandt andet af afstand, antal køretøjer, bilens stand og behovet for kran eller særlig læsning. Vi beregner derfor din autotransport pris ud fra den konkrete opgave. Du kan kontakte os og få et tilbud, før transporten planlægges."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Autohjælp når bilen ikke kan køre videre"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når et køretøj ikke kan fortsætte, har du brug for en løsning, der passer til situationen. Vores vagtcentral er åben døgnet rundt og tager imod akutte henvendelser om autohjælp. Her kan du få afklaret, om behovet er vejhjælp, bugsering, bjærgning eller fritrækning."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Hvornår er bugsering eller bjærgning den rigtige løsning"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Bugsering bruges typisk, når bilen skal flyttes til et værksted eller en anden adresse. Er bilen fastkørt eller svært tilgængelig, kan bjærgning eller fritrækning være nødvendig. Vi vurderer opgaven og vælger et egnet bjærgningskøretøj til situationen."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Når opgaven kræver mere end almindelig autotransport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "MC Transport har autotransport som kerneområde og løser også maskintransport, krantransport og godstransport. Vi kører blandt andet med entreprenørmateriel, containere og både. Opgaven kan udføres med sengetrailer eller gardintrailer med medbringertruck, når transporten og forholdene ved aflæsning kræver det."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for at samle transport og midlertidig opbevaring, tilbyder vi også opbevaring af køretøjer og gods. Hos MC Transport ser vi på hele opgaven, så valg af køretøj, læsning og levering hænger sammen. Læs mere om os og vores materiel."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Lad os planlægge den rigtige transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fortæl os, hvad der skal flyttes, hvor det skal hentes og leveres, og om køretøjet kan køre. De oplysninger gør det lettere at vælge materiel og planlægge opgaven. Kontakt MC Transport for autotransport i hele Danmark eller akut hjælp via vores vagtcentral døgnet rundt."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad koster autotransport?",
          answer_tag: "p",
          answer: "En autotransport pris hos MC Transport beregnes ud fra afstand, antal køretøjer, bilens stand og behovet for kran eller særlig læsning. Derfor gives der et konkret tilbud, før transporten planlægges."
        },
        {
          question_tag: "h4",
          question: "Kan man få autotransport i hele Danmark?",
          answer_tag: "p",
          answer: "Ja. MC Transport udfører autotransport hele Danmark rundt for både private og virksomheder. Virksomheden kan flytte én bil eller flere køretøjer med materiel, der tilpasses den konkrete opgave."
        },
        {
          question_tag: "h4",
          question: "Hvilke typer biler kan transporteres?",
          answer_tag: "p",
          answer: "MC Transport tilbyder det, der ofte søges som MC autotransport: transport af nye, brugte, skadede og brændte biler. Både køreklare biler og køretøjer, der kræver særlig læsning, kan håndteres."
        },
        {
          question_tag: "h4",
          question: "Hvornår har man brug for autohjælp, bugsering eller bjærgning?",
          answer_tag: "p",
          answer: "Autohjælp er relevant, når bilen ikke kan fortsætte. Hos MC Transport bruges bugsering typisk til at flytte bilen til et værksted eller en anden adresse, mens bjærgning eller fritrækning kan være nødvendig, hvis bilen er fastkørt eller svært tilgængelig. Vagtcentralen er åben døgnet rundt."
        },
        {
          question_tag: "h4",
          question: "Hvordan transporteres en bil, der ikke kan køre?",
          answer_tag: "p",
          answer: "MC Transport vurderer bilens stand og adgangsforholdene og vælger egnet materiel, eksempelvis en skydeladsbil, kranbil eller et bjærgningskøretøj. Ved transport af flere biler kan der bruges en transporter med plads til flere køretøjer."
        },
        {
          question_tag: "h4",
          question: "Kan et transportfirma også flytte maskiner, containere og både?",
          answer_tag: "p",
          answer: "Ja. MC Transport udfører maskintransport, krantransport og godstransport af blandt andet entreprenørmateriel, containere og både. Opgaven kan løses med sengetrailer eller gardintrailer med medbringertruck, når læsning og aflæsning kræver det."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af autotransport?",
          answer_tag: "p",
          answer: "MC Transport har brug for at vide, hvad der skal flyttes, hvor det skal hentes og leveres, og om køretøjet kan køre. Oplysningerne bruges til at vælge det rette materiel og planlægge læsning og levering."
        },
        {
          question_tag: "h4",
          question: "Kan køretøjer og gods opbevares midlertidigt?",
          answer_tag: "p",
          answer: "Ja. MC Transport tilbyder midlertidig opbevaring af køretøjer og gods, når opbevaringen skal kombineres med transportopgaven."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad koster autotransport?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En autotransport pris hos MC Transport beregnes ud fra afstand, antal køretøjer, bilens stand og behovet for kran eller særlig læsning. Derfor gives der et konkret tilbud, før transporten planlægges."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få autotransport i hele Danmark?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport udfører autotransport hele Danmark rundt for både private og virksomheder. Virksomheden kan flytte én bil eller flere køretøjer med materiel, der tilpasses den konkrete opgave."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke typer biler kan transporteres?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport tilbyder det, der ofte søges som MC autotransport: transport af nye, brugte, skadede og brændte biler. Både køreklare biler og køretøjer, der kræver særlig læsning, kan håndteres."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår har man brug for autohjælp, bugsering eller bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Autohjælp er relevant, når bilen ikke kan fortsætte. Hos MC Transport bruges bugsering typisk til at flytte bilen til et værksted eller en anden adresse, mens bjærgning eller fritrækning kan være nødvendig, hvis bilen er fastkørt eller svært tilgængelig. Vagtcentralen er åben døgnet rundt."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan transporteres en bil, der ikke kan køre?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport vurderer bilens stand og adgangsforholdene og vælger egnet materiel, eksempelvis en skydeladsbil, kranbil eller et bjærgningskøretøj. Ved transport af flere biler kan der bruges en transporter med plads til flere køretøjer."
          }
        },
        {
          "@type": "Question",
          name: "Kan et transportfirma også flytte maskiner, containere og både?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport udfører maskintransport, krantransport og godstransport af blandt andet entreprenørmateriel, containere og både. Opgaven kan løses med sengetrailer eller gardintrailer med medbringertruck, når læsning og aflæsning kræver det."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af autotransport?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport har brug for at vide, hvad der skal flyttes, hvor det skal hentes og leveres, og om køretøjet kan køre. Oplysningerne bruges til at vælge det rette materiel og planlægge læsning og levering."
          }
        },
        {
          "@type": "Question",
          name: "Kan køretøjer og gods opbevares midlertidigt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport tilbyder midlertidig opbevaring af køretøjer og gods, når opbevaringen skal kombineres med transportopgaven."
          }
        }
      ]
    }
  },
  {
    page_id: "86e08d85-61e8-497b-9f2d-76a86f92974c",
    url_path: "/autohjaelp",
    badge: "Døgnvagt 24/7 · Landsdækkende",
    heroImage: "/_assets/bjaergningsvogn-autohjaelp-havareret-lastbil.jpg",
    seo: {
      title_tag: "Autohjælp 24/7 i hele Danmark | MC Transport",
      meta_description: "Få autohjælp døgnet rundt i hele Danmark hos MC Transport. Vi hjælper med vejhjælp, fritrækning, bugsering og bjærgning, kontakt os for en konkret pris."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Autohjælp 24/7 når dit køretøj ikke kan køre videre"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når bilen havarerer, sidder fast eller er blevet skadet, har du brug for en klar løsning. Hos MC Transport får du autohjælp 24/7 via vores døgnåbne vagtcentral. Vi hjælper med vejhjælp, fritrækning, bjærgning og videre transport af køretøjet i hele Danmark."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad kan vores vejhjælp gøre for dig?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vejhjælp begynder med at få overblik over bilen og stedet omkring den. Vi afklarer, om køretøjet kan flyttes sikkert, eller om der er behov for fritrækning, bugsering eller bjærgning. På den måde kan vi vælge et egnet køretøj og planlægge den videre transport."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Fra havari til sikker transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et havari kan ske på en almindelig vej, ved en virksomhed eller et sted, hvor pladsen er trang. Oplys derfor hvor køretøjet står, hvad der er sket, og om hjul og styring er påvirket. De oplysninger gør det lettere at vurdere adgangsforholdene og behovet for transport."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Hvis bilen ikke kan fortsætte ved egen kraft, kan den blive transporteret til et aftalt sted. Du kan læse mere om bugsering af bil. Er køretøjet kørt af vejen eller står svært tilgængeligt, kan bjærgning være den rette indsats."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Fritrækning når køretøjet sidder fast og ikke selv kan komme fri."
          },
          {
            tag: "li",
            text: "Bugsering når bilen ikke længere kan køre sikkert videre."
          },
          {
            tag: "li",
            text: "Bjærgning når skader eller placering kræver særligt materiel."
          },
          {
            tag: "li",
            text: "Transport til et aftalt værksted, opbevaringssted eller en anden adresse."
          }
        ]
      },
      {
        type: "heading",
        tag: "h3",
        text: "Når skaden kræver det rette materiel"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skadede og brændte biler kan ikke altid håndteres som et almindeligt køretøj. MC Transport råder over skydeladsbiler, kranbiler og et bjærgningskøretøj, så materiellet kan vælges efter bilens tilstand og placering. Vi kan også stå for den efterfølgende transport."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Sådan bestiller du autohjælp 24/7"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved akut behov kan du kontakte vores 24/7 vagtcentral hele døgnet. Autohjælp 24/7 betyder, at din henvendelse kan blive modtaget, når problemet opstår. Den konkrete assistance afhænger af situationen, køretøjet og det materiel, der er nødvendigt for opgaven."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Fortæl os hvor bilen står"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du ringer, er det en hjælp at kende din placering, køretøjets type og registreringsnummer samt en kort beskrivelse af hændelsen. Fortæl også, om bilen står til fare eller er vanskelig at komme hen til, og hvor den eventuelt skal transporteres hen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du ikke alle oplysninger klar, tager vi udgangspunkt i det, du ved. Du kan kontakte os om den akutte situation eller sende en forespørgsel via vores kontaktside. Ved planlagte transporter kan afhentning, levering og særlige adgangsforhold aftales på forhånd."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Autohjælp priser, hvad afgør det samlede beløb?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Priser på autohjælp afhænger af den konkrete opgave. Afstand, køretøjets størrelse, placering, skadens omfang og behovet for særligt materiel kan påvirke beløbet. Derfor kan vi ikke give én retvisende pris, før vi ved, hvilken hjælp og transport situationen kræver."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Køretøjets type, størrelse og aktuelle tilstand."
          },
          {
            tag: "li",
            text: "Placeringen og adgangsforholdene omkring køretøjet."
          },
          {
            tag: "li",
            text: "Afstanden til det ønskede leveringssted."
          },
          {
            tag: "li",
            text: "Behovet for kran, skydelad, fritrækning eller bjærgning."
          }
        ]
      },
      {
        type: "heading",
        tag: "h3",
        text: "Priser autohjælp og transport i samme vurdering"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Du er velkommen til at spørge om priser, autohjælp og den videre transport i samme henvendelse. Når vi kender opgaven, kan vi vurdere den relevante indsats og give et tilbud, der tager højde for køretøj, afstand, placering og nødvendigt materiel."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Billig autohjælp handler også om den rigtige løsning"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Billig autohjælp bør vurderes ud fra hele opgaven og ikke kun det første beløb. Hvis der fra start vælges materiel, som passer til køretøjets tilstand, kan forløbet planlægges mere præcist. Vores fokus er en faglig vurdering og en løsning, der matcher behovet."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Kontakt MC Transport, når du har brug for vejhjælp i Danmark, eller når et køretøj skal flyttes efter havari eller skade. Vi hjælper også med transport af nye og brugte biler. Læs mere om vores autotransport, eller kontakt os for at få vurderet din opgave."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad dækker autohjælp 24/7 over?",
          answer_tag: "p",
          answer: "Hos MC Transport betyder autohjælp 24/7, at den døgnåbne vagtcentral kan kontaktes, når et køretøj havarerer, sidder fast eller er blevet skadet. Hjælpen kan omfatte vejhjælp, fritrækning, bugsering, bjærgning og videre transport i hele Danmark."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på vejhjælp, fritrækning, bugsering og bjærgning?",
          answer_tag: "p",
          answer: "MC Transport bruger vejhjælp til at skabe overblik over situationen og vælge den rette løsning. Fritrækning bruges, når køretøjet sidder fast, bugsering når det ikke kan køre sikkert videre, og bjærgning når skader eller en vanskelig placering kræver særligt materiel."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give, når man bestiller autohjælp?",
          answer_tag: "p",
          answer: "MC Transport anbefaler, at du oplyser køretøjets placering, type og registreringsnummer samt beskriver, hvad der er sket. Fortæl også, om hjul eller styring er påvirket, om bilen står til fare, og hvor den eventuelt skal transporteres hen. Har du ikke alle oplysninger, tager vagtcentralen udgangspunkt i det, du ved."
        },
        {
          question_tag: "h4",
          question: "Hvad påvirker priser på autohjælp?",
          answer_tag: "p",
          answer: "Ved spørgsmål om autohjælp priser, priser på autohjælp eller priser autohjælp vurderer MC Transport den konkrete opgave. Prisen afhænger blandt andet af køretøjets type og tilstand, placeringen, adgangsforholdene, transportafstanden og behovet for kran, skydelad, fritrækning eller bjærgning."
        },
        {
          question_tag: "h4",
          question: "Hvordan får man en konkret pris på autohjælp og transport?",
          answer_tag: "p",
          answer: "MC Transport kan vurdere autohjælp og den videre transport i samme henvendelse. Når virksomheden kender køretøjets tilstand, placering, leveringssted og behovet for særligt materiel, kan der gives et tilbud, som tager højde for hele opgaven."
        },
        {
          question_tag: "h4",
          question: "Hvad skal man se efter, når man vælger billig autohjælp?",
          answer_tag: "p",
          answer: "Billig autohjælp bør ifølge MC Transport vurderes ud fra hele opgaven og ikke kun det første beløb. Det rette materiel fra begyndelsen kan gøre forløbet mere præcist og sikre, at hjælpen passer til køretøjets tilstand, placering og transportbehov."
        },
        {
          question_tag: "h4",
          question: "Kan skadede og brændte biler få autohjælp og transport?",
          answer_tag: "p",
          answer: "Ja. MC Transport kan håndtere skadede og brændte biler med blandt andet skydeladsbiler, kranbiler og bjærgningskøretøj. Materiellet vælges efter bilens tilstand og placering, hvorefter køretøjet kan transporteres til et aftalt værksted, opbevaringssted eller en anden adresse."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad dækker autohjælp 24/7 over?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Hos MC Transport betyder autohjælp 24/7, at den døgnåbne vagtcentral kan kontaktes, når et køretøj havarerer, sidder fast eller er blevet skadet. Hjælpen kan omfatte vejhjælp, fritrækning, bugsering, bjærgning og videre transport i hele Danmark."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på vejhjælp, fritrækning, bugsering og bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport bruger vejhjælp til at skabe overblik over situationen og vælge den rette løsning. Fritrækning bruges, når køretøjet sidder fast, bugsering når det ikke kan køre sikkert videre, og bjærgning når skader eller en vanskelig placering kræver særligt materiel."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give, når man bestiller autohjælp?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport anbefaler, at du oplyser køretøjets placering, type og registreringsnummer samt beskriver, hvad der er sket. Fortæl også, om hjul eller styring er påvirket, om bilen står til fare, og hvor den eventuelt skal transporteres hen. Har du ikke alle oplysninger, tager vagtcentralen udgangspunkt i det, du ved."
          }
        },
        {
          "@type": "Question",
          name: "Hvad påvirker priser på autohjælp?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved spørgsmål om autohjælp priser, priser på autohjælp eller priser autohjælp vurderer MC Transport den konkrete opgave. Prisen afhænger blandt andet af køretøjets type og tilstand, placeringen, adgangsforholdene, transportafstanden og behovet for kran, skydelad, fritrækning eller bjærgning."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan får man en konkret pris på autohjælp og transport?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport kan vurdere autohjælp og den videre transport i samme henvendelse. Når virksomheden kender køretøjets tilstand, placering, leveringssted og behovet for særligt materiel, kan der gives et tilbud, som tager højde for hele opgaven."
          }
        },
        {
          "@type": "Question",
          name: "Hvad skal man se efter, når man vælger billig autohjælp?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Billig autohjælp bør ifølge MC Transport vurderes ud fra hele opgaven og ikke kun det første beløb. Det rette materiel fra begyndelsen kan gøre forløbet mere præcist og sikre, at hjælpen passer til køretøjets tilstand, placering og transportbehov."
          }
        },
        {
          "@type": "Question",
          name: "Kan skadede og brændte biler få autohjælp og transport?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport kan håndtere skadede og brændte biler med blandt andet skydeladsbiler, kranbiler og bjærgningskøretøj. Materiellet vælges efter bilens tilstand og placering, hvorefter køretøjet kan transporteres til et aftalt værksted, opbevaringssted eller en anden adresse."
          }
        }
      ]
    }
  },
  {
    page_id: "a736b78a-d3f5-40bd-b351-1b86f6b3470f",
    url_path: "/bugsering-af-bil",
    badge: "Personbiler & Varevogne",
    heroImage: "/_assets/man-autotransporter-fejeblad-bugsering.png",
    seo: {
      title_tag: "Bugsering af bil i hele Danmark | MC Transport",
      meta_description: "Få sikker bugsering af bil til værksted eller anden adresse i hele Danmark. MC Transport står klar døgnet rundt med autohjælp, bjærgning og et tilbud."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Bugsering af bil med autohjælp i hele Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når bilen ikke kan køre videre, hjælper MC Transport med bugsering af bil i hele Danmark. Vi håndterer både akutte og planlagte opgaver og kan transportere bilen til værksted, opbevaring eller en anden aftalt adresse. Vores vagtcentral tager imod akutte henvendelser hele døgnet."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår er bugsering den sikre vej videre"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Bugsering er relevant, når et køretøj har teknisk nedbrud, er beskadiget efter et uheld eller ikke bør køre videre. I stedet for at tage chancer i trafikken kan bilen flyttes med et egnet bjærgningskøretøj eller en skydeladsbil, alt efter bilens stand og placering."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Når bjærgning kommer før transporten"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Er bilen havareret langs vejen, begynder hjælpen med en vurdering af situationen. Hvis bilen kan læsses direkte, sørger vi for transporten. Står den fast, ligger den i en grøft eller er svært skadet, kan der først være behov for fritrækning eller bjærgning."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Bugsering af bil til værksted uden unødige omveje"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved bugsering af bil til værksted aftaler vi afhentningssted og destination ud fra den konkrete opgave. Det gælder både ved havari på vejen og ved en bil, der holder hjemme eller hos en virksomhed. Oplys gerne bilens mærke og model, dens stand og om hjulene kan rulle."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Det rigtige materiel afhænger af bilen og adgangsforholdene. MC Transport råder blandt andet over skydeladsbiler, kranbiler og bjærgningskøretøjer. Det giver mulighed for at håndtere almindelige biler samt skadede og brændte køretøjer, hvor læsningen kræver en anden tilgang."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for hjælp her og nu, kan du kontakte vores 24/7 vagtcentral. På siden om autohjælp kan du læse mere om akut assistance. Når vi kender placeringen, bilens tilstand og den ønskede destination, kan opgaven vurderes på et relevant grundlag."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad bestemmer prisen på bugsering af bil"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen afhænger af den konkrete transport. Afstand, biltype, køretøjets tilstand, adgang på stedet og behovet for særligt materiel kan have betydning. En søgning som bugsering af bil pris kan derfor ikke stå alene, da beløbet først kan vurderes, når opgaven er beskrevet."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Oplysninger der giver et mere præcist tilbud"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "For at få et brugbart tilbud er det en fordel at beskrive opgaven så konkret som muligt. Det gør det lettere at vurdere transportformen og vælge relevant materiel. Hav derfor gerne de vigtigste oplysninger klar, når du henvender dig om en planlagt eller akut bugsering."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Afhentningssted og ønsket leveringssted"
          },
          {
            tag: "li",
            text: "Bilens mærke, model og aktuelle stand"
          },
          {
            tag: "li",
            text: "Adgangsforholdene omkring bilen"
          },
          {
            tag: "li",
            text: "Behov for løft, fritrækning eller særlig læsning"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvilke regler gælder for bugsering af bil"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Regler for bugsering af bil afhænger blandt andet af, om bilen slæbes med tov eller stang, eller om den transporteres på et bjærgningskøretøj. Ved privat slæbning skal bilens stand, forbindelsen mellem køretøjerne og trafiksituationen være forsvarlig."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Styretøj og bremser på den slæbte bil skal fungere"
          },
          {
            tag: "li",
            text: "Der skal sidde en fører i bilen under slæbningen"
          },
          {
            tag: "li",
            text: "Afstanden mellem køretøjerne må som udgangspunkt højst være fire meter"
          },
          {
            tag: "li",
            text: "En forbindelse over to meter skal være tydeligt markeret"
          }
        ]
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Reglerne kan variere med køretøj og situation, og særlige forhold kan gælde på motorvej. Er du i tvivl om bugsering af bil regler, bør du ikke begynde på privat slæbning. Få i stedet hjælp til at flytte bilen, og kontrollér altid de aktuelle krav hos relevante myndigheder."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Få autohjælp når bilen står stille"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når bilen ikke kan fortsætte, er det vigtigste at skabe overblik og vælge den rette hjælp. MC Transport løser bugsering, autotransport, bjærgning og fritrækning i hele Danmark. Den akutte indsats håndteres via vores 24/7 vagtcentral, så du kan henvende dig, når behovet opstår."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Kontakt os med bilens placering, tilstand og den ønskede destination. Så kan vi afklare, om opgaven kræver direkte transport, bugsering af bil til værksted eller bjærgning før transport. Du kan kontakte MC Transport for at få hjælp eller bede om et tilbud."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvornår er bugsering af bil den sikre løsning?",
          answer_tag: "p",
          answer: "Bugsering af bil er relevant, når bilen har teknisk nedbrud, er beskadiget efter et uheld eller ikke bør køre videre. MC Transport vurderer bilens stand og placering og flytter den med et egnet bjærgningskøretøj, en skydeladsbil eller andet relevant materiel."
        },
        {
          question_tag: "h4",
          question: "Hvordan foregår bugsering af bil til værksted?",
          answer_tag: "p",
          answer: "Ved bugsering af bil til værksted aftaler MC Transport afhentningssted og destination ud fra den konkrete opgave. Kunden bør oplyse bilens mærke, model og tilstand, adgangsforholdene samt om hjulene kan rulle, så det rette materiel kan vælges."
        },
        {
          question_tag: "h4",
          question: "Hvad koster det at få bugseret en bil?",
          answer_tag: "p",
          answer: "En bugsering af bil pris afhænger blandt andet af transportafstanden, biltypen, køretøjets tilstand, adgangsforholdene og behovet for særligt materiel. MC Transport kan give et mere præcist tilbud, når afhentningssted, leveringssted og opgavens omfang er beskrevet."
        },
        {
          question_tag: "h4",
          question: "Hvilke regler gælder ved privat bugsering af bil?",
          answer_tag: "p",
          answer: "Ved privat slæbning skal styretøj og bremser på den slæbte bil fungere, og der skal sidde en fører i bilen. Afstanden mellem køretøjerne må som udgangspunkt højst være fire meter, og en forbindelse over to meter skal markeres tydeligt. Bugsering af bil regler kan variere efter køretøj og situation, særligt på motorvej, så MC Transport anbefaler at kontrollere de aktuelle myndighedskrav eller få professionel hjælp."
        },
        {
          question_tag: "h4",
          question: "Hvornår kræves bjærgning eller fritrækning før bugsering?",
          answer_tag: "p",
          answer: "Bjærgning eller fritrækning kan være nødvendig, hvis bilen sidder fast, ligger i en grøft eller er så beskadiget, at den ikke kan læsses direkte. MC Transport vurderer situationen og kan udføre fritrækning eller bjærgning, før den videre bugsering gennemføres."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give for at få et tilbud på bugsering?",
          answer_tag: "p",
          answer: "For at få et brugbart tilbud bør man oplyse afhentningssted og ønsket leveringssted, bilens mærke, model og aktuelle stand samt adgangsforholdene omkring bilen. MC Transport skal også vide, om opgaven kræver løft, fritrækning eller særlig læsning."
        },
        {
          question_tag: "h4",
          question: "Kan man få akut autohjælp og bugsering døgnet rundt?",
          answer_tag: "p",
          answer: "Ja. MC Transports 24/7-vagtcentral tager imod akutte henvendelser om autohjælp, bugsering, bjærgning og fritrækning hele døgnet. Oplys bilens placering, tilstand og ønskede destination, så behovet for hjælp og materiel kan vurderes."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvornår er bugsering af bil den sikre løsning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bugsering af bil er relevant, når bilen har teknisk nedbrud, er beskadiget efter et uheld eller ikke bør køre videre. MC Transport vurderer bilens stand og placering og flytter den med et egnet bjærgningskøretøj, en skydeladsbil eller andet relevant materiel."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan foregår bugsering af bil til værksted?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved bugsering af bil til værksted aftaler MC Transport afhentningssted og destination ud fra den konkrete opgave. Kunden bør oplyse bilens mærke, model og tilstand, adgangsforholdene samt om hjulene kan rulle, så det rette materiel kan vælges."
          }
        },
        {
          "@type": "Question",
          name: "Hvad koster det at få bugseret en bil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En bugsering af bil pris afhænger blandt andet af transportafstanden, biltypen, køretøjets tilstand, adgangsforholdene og behovet for særligt materiel. MC Transport kan give et mere præcist tilbud, når afhentningssted, leveringssted og opgavens omfang er beskrevet."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke regler gælder ved privat bugsering af bil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved privat slæbning skal styretøj og bremser på den slæbte bil fungere, og der skal sidde en fører i bilen. Afstanden mellem køretøjerne må som udgangspunkt højst være fire meter, og en forbindelse over to meter skal markeres tydeligt. Bugsering af bil regler kan variere efter køretøj og situation, særligt på motorvej, så MC Transport anbefaler at kontrollere de aktuelle myndighedskrav eller få professionel hjælp."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår kræves bjærgning eller fritrækning før bugsering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bjærgning eller fritrækning kan være nødvendig, hvis bilen sidder fast, ligger i en grøft eller er så beskadiget, at den ikke kan læsses direkte. MC Transport vurderer situationen og kan udføre fritrækning eller bjærgning, før den videre bugsering gennemføres."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give for at få et tilbud på bugsering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For at få et brugbart tilbud bør man oplyse afhentningssted og ønsket leveringssted, bilens mærke, model og aktuelle stand samt adgangsforholdene omkring bilen. MC Transport skal også vide, om opgaven kræver løft, fritrækning eller særlig læsning."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få akut autohjælp og bugsering døgnet rundt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transports 24/7-vagtcentral tager imod akutte henvendelser om autohjælp, bugsering, bjærgning og fritrækning hele døgnet. Oplys bilens placering, tilstand og ønskede destination, så behovet for hjælp og materiel kan vurderes."
          }
        }
      ]
    }
  },
  {
    page_id: "c5cbd121-c658-47a2-8093-53100b86133e",
    url_path: "/bugsering-af-lastbil",
    badge: "Tungvogn · Busser & Lastbiler",
    heroImage: "/_assets/bjaerger-med-lastbil-18-03-2025-347.jpg",
    seo: {
      title_tag: "Bugsering af lastbil 24/7 | MC Transport",
      meta_description: "Få bugsering af lastbil i hele Danmark, når havari eller uheld stopper driften. MC Transport har døgnvagt og hjælper hurtigt med bugsering, bjærgning og fritrækning."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Bugsering af lastbil, når driften ikke kan vente"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når en lastbil ikke kan køre videre, kan et driftsstop hurtigt påvirke både chauffør, levering og den næste opgave. MC Transport hjælper med bugsering af lastbil, autohjælp og bjærgning i hele Danmark. Ved akutte behov kan du kontakte vores 24/7 vagtcentral."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Autohjælp til lastbil, når havari stopper turen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et motorstop, et uheld eller en fastkørsel kræver en løsning, der passer til køretøjets størrelse, placering og stand. Vi hjælper med at få overblik over behovet og kan stå for bugsering, fritrækning eller transport, når lastbilen ikke selv kan fortsætte."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Står lastbilen et udsat sted, bør sikkerheden komme først. Brug advarselsblink og relevant afmærkning, hvis det kan ske forsvarligt, og oplys så præcist som muligt, hvor køretøjet holder. Ved akut fare for trafikken skal du kontakte alarmcentralen."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Havari hvor lastbilen ikke kan køre videre"
          },
          {
            tag: "li",
            text: "Uheld med behov for flytning eller transport"
          },
          {
            tag: "li",
            text: "Fastkørsel hvor køretøjet skal trækkes fri"
          },
          {
            tag: "li",
            text: "Transport til værksted eller en anden aftalt placering"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår er bugsering eller bjærgning den rette løsning?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Valget mellem bugsering og bjærgning afhænger især af, om lastbilen står tilgængeligt, og om den først skal bringes fri eller stabiliseres. Skader, underlag, pladsforhold, trailer og last kan også få betydning for, hvilket materiel der er relevant til opgaven."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Bugsering af lastbil ved et almindeligt havari"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Bugsering af lastbil er typisk relevant, når køretøjet ikke kan køre, men kan flyttes fra stedet på en kontrolleret måde. Målet kan være et værksted, en holdeplads eller en anden aftalt adresse. Den konkrete løsning vurderes ud fra hele køretøjet og forholdene på stedet."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Bjærgning af lastbil, når køretøjet sidder fast"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved bjærgning af lastbil skal køretøjet ofte først trækkes fri fra eksempelvis en grøft, blødt underlag, mudder eller sne. En skadet eller væltet lastbil kan også kræve andet materiel end en enkel bugsering. Derfor er placering og skadens omfang vigtige oplysninger."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Det rette bjærgningskøretøj gør en forskel"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et bjærgningskøretøj, også kendt som en tow truck, bruges til at flytte et køretøj, der er havareret eller beskadiget. MC Transport råder også over skydeladsbiler og kranbiler, så opgaven kan ses i forhold til køretøjets stand og behovet for løft eller transport."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen på autohjælp til lastbil og bugsering afhænger af den konkrete opgave. Afstand, placering, køretøjets stand og behovet for særligt materiel kan spille ind. Kontakt os med de vigtigste oplysninger, så der kan tages stilling til opgaven og gives et tilbud."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Lastbilens type, stand og registreringsnummer"
          },
          {
            tag: "li",
            text: "Den præcise placering og adgangsforholdene"
          },
          {
            tag: "li",
            text: "Oplysninger om trailer, last og eventuelle skader"
          },
          {
            tag: "li",
            text: "Ønsket destination for bugsering eller transport"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Få hjælp til lastbilen i hele Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vi løser opgaver i hele Danmark og har en 24/7 vagtcentral til akut assistance. Har du brug for autohjælp, kan du kontakte os, når driften går i stå. Du kan også læse mere om bjærgning og vores løsning med tow truck."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fortæl os, hvor lastbilen står, hvad der er sket, og om der er trailer eller last med. Så har vi et bedre grundlag for at tale opgaven igennem. Brug vores kontaktside, hvis du vil bestille hjælp eller få et tilbud på bugsering af lastbil."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvornår er bugsering af lastbil nødvendigt?",
          answer_tag: "p",
          answer: "Bugsering af lastbil er typisk nødvendigt efter havari eller uheld, når køretøjet ikke selv kan fortsætte, men kan flyttes kontrolleret. MC Transport vurderer lastbilens stand, placering, trailer og last, før den bugseres til et værksted, en holdeplads eller en anden aftalt destination."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på bugsering og bjærgning af lastbil?",
          answer_tag: "p",
          answer: "Bugsering bruges normalt, når en lastbil står tilgængeligt og kan flyttes kontrolleret. Bjærgning af lastbil er relevant, når køretøjet først skal trækkes fri eller stabiliseres, eksempelvis efter fastkørsel i en grøft, mudder, sne eller blødt underlag. MC Transport vurderer forholdene og vælger en passende løsning."
        },
        {
          question_tag: "h4",
          question: "Kan man få autohjælp lastbil døgnet rundt?",
          answer_tag: "p",
          answer: "Ja. MC Transport tilbyder autohjælp til lastbil og har en 24/7-vagtcentral til akutte opgaver i hele Danmark. Hjælpen kan omfatte bugsering, fritrækning, bjærgning eller transport, når lastbilen ikke kan køre videre."
        },
        {
          question_tag: "h4",
          question: "Kan en fastkørt lastbil trækkes fri?",
          answer_tag: "p",
          answer: "En fastkørt lastbil kan ofte trækkes fri, men løsningen afhænger blandt andet af køretøjets placering, underlaget, eventuelle skader samt trailer og last. MC Transport bruger oplysningerne om situationen til at vurdere behovet for fritrækning, bjærgning eller efterfølgende transport."
        },
        {
          question_tag: "h4",
          question: "Hvilket bjærgningskøretøj bruges til en lastbil?",
          answer_tag: "p",
          answer: "Valget af bjærgningskøretøj afhænger af lastbilens type, stand, placering og behovet for løft eller transport. Et bjærgningskøretøj kaldes også en tow truck. MC Transport råder desuden over skydeladsbiler og kranbiler, så materiellet kan tilpasses den konkrete opgave."
        },
        {
          question_tag: "h4",
          question: "Hvad koster bugsering af en lastbil?",
          answer_tag: "p",
          answer: "Prisen på bugsering og autohjælp til lastbil afhænger af den konkrete opgave. Afstand, adgangsforhold, køretøjets stand og behovet for særligt materiel kan påvirke prisen. MC Transport kan vurdere opgaven og give et tilbud ud fra de relevante oplysninger."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af lastbilbugsering?",
          answer_tag: "p",
          answer: "MC Transport har brug for lastbilens type, stand og registreringsnummer samt den præcise placering og adgangsforholdene. Oplys også om trailer, last, eventuelle skader og den ønskede destination for bugsering eller transport."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvornår er bugsering af lastbil nødvendigt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bugsering af lastbil er typisk nødvendigt efter havari eller uheld, når køretøjet ikke selv kan fortsætte, men kan flyttes kontrolleret. MC Transport vurderer lastbilens stand, placering, trailer og last, før den bugseres til et værksted, en holdeplads eller en anden aftalt destination."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på bugsering og bjærgning af lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bugsering bruges normalt, når en lastbil står tilgængeligt og kan flyttes kontrolleret. Bjærgning af lastbil er relevant, når køretøjet først skal trækkes fri eller stabiliseres, eksempelvis efter fastkørsel i en grøft, mudder, sne eller blødt underlag. MC Transport vurderer forholdene og vælger en passende løsning."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få autohjælp lastbil døgnet rundt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport tilbyder autohjælp til lastbil og har en 24/7-vagtcentral til akutte opgaver i hele Danmark. Hjælpen kan omfatte bugsering, fritrækning, bjærgning eller transport, når lastbilen ikke kan køre videre."
          }
        },
        {
          "@type": "Question",
          name: "Kan en fastkørt lastbil trækkes fri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En fastkørt lastbil kan ofte trækkes fri, men løsningen afhænger blandt andet af køretøjets placering, underlaget, eventuelle skader samt trailer og last. MC Transport bruger oplysningerne om situationen til at vurdere behovet for fritrækning, bjærgning eller efterfølgende transport."
          }
        },
        {
          "@type": "Question",
          name: "Hvilket bjærgningskøretøj bruges til en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Valget af bjærgningskøretøj afhænger af lastbilens type, stand, placering og behovet for løft eller transport. Et bjærgningskøretøj kaldes også en tow truck. MC Transport råder desuden over skydeladsbiler og kranbiler, så materiellet kan tilpasses den konkrete opgave."
          }
        },
        {
          "@type": "Question",
          name: "Hvad koster bugsering af en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Prisen på bugsering og autohjælp til lastbil afhænger af den konkrete opgave. Afstand, adgangsforhold, køretøjets stand og behovet for særligt materiel kan påvirke prisen. MC Transport kan vurdere opgaven og give et tilbud ud fra de relevante oplysninger."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af lastbilbugsering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport har brug for lastbilens type, stand og registreringsnummer samt den præcise placering og adgangsforholdene. Oplys også om trailer, last, eventuelle skader og den ønskede destination for bugsering eller transport."
          }
        }
      ]
    }
  },
  {
    page_id: "13dc6e22-51b4-4692-bbc5-301ac7d7b81f",
    url_path: "/bjaergning",
    badge: "Scania R660 & Uni Man 4x4",
    heroImage: "/_assets/volvo-bjaergningsvogn-motorvej-assistance.png",
    seo: {
      title_tag: "Bjærgning af biler døgnet rundt | MC Transport",
      meta_description: "Få professionel bjærgning af biler og fritrækning i hele Danmark. MC Transport har døgnvagt og det rette materiel til sikker autohjælp og videre transport."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Bjærgning, når dit køretøj ikke kan komme fri"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når et køretøj står i grøften, sidder fast eller er så skadet, at det ikke kan flyttes normalt, er der brug for mere end almindelig transport. MC Transport udfører bjærgning af biler i hele Danmark og vurderer både placering, stand og adgangsforhold, før opgaven sættes i gang."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår er bjærgning og redning den rette hjælp?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved bjærgning og redning skal et køretøj først bringes ud af en vanskelig eller usikker position. Det kan være efter et uheld, en fastkørsel i blødt underlag eller en skade, hvor hjul og styretøj ikke fungerer som normalt. Opgaven vurderes ud fra forholdene på stedet."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fritrækning er ofte den rigtige løsning, når bilen kan køre videre eller læsses, så snart den er trukket fri. Er bilen svært beskadiget, eller står den på en måde, som kræver løft og særlig håndtering, kan der i stedet være behov for et bjærgningskøretøj og efterfølgende transport."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Fastkørsel i en grøft, sne eller mudder"
          },
          {
            tag: "li",
            text: "Skader som gør normal flytning umulig"
          },
          {
            tag: "li",
            text: "Adgang der kræver særligt materiel eller løft"
          },
          {
            tag: "li",
            text: "Videre transport til værksted eller opbevaring"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvilket bjærgningskøretøj passer til opgaven?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Valget af materiel afhænger af køretøjets størrelse, skadens omfang og mulighederne for at komme tæt på. MC Transport råder over blandt andet skydeladsbiler og kranbiler. Det giver flere muligheder ved bjærgning af biler, som ikke kan trækkes eller læsses på almindelig vis."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et bjærgningskøretøj skal passe til den konkrete situation. Derfor er billeder, en præcis placering og oplysninger om køretøjets stand nyttige, når vi vurderer opgaven. Vi lover ikke en bestemt metode på forhånd, men tager udgangspunkt i de faktiske forhold og det materiel, der er nødvendigt."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Fritrækning, når bilen sidder fast"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved fritrækning handler det om at få bilen tilbage på et stabilt underlag uden at gøre situationen værre. Underlag, hældning, skader og plads omkring bilen har betydning for fremgangsmåden. Når bilen er fri, vurderer vi, om den kan fortsætte, eller om den skal transporteres."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Forsøg ikke selv at trække køretøjet fri, hvis du er usikker på fæstepunkter, vægt eller underlag. En forkert trækretning kan belaste bilen og gøre adgangen vanskeligere. Oplys i stedet, hvor bilen står, og om den er til gene eller befinder sig tæt på den øvrige trafik."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Bjærgning af biler med omfattende skader"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skadede og brændte biler kan kræve en anden håndtering end et almindeligt havari. Hjul kan være låst, karrosseriet kan være ustabilt, og bilen kan stå svært tilgængeligt. Vi vurderer derfor, om opgaven kræver skydelad, kran eller en kombination med videre transport."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når køretøjet er løftet eller trukket fri, kan det transporteres til den aftalte destination. MC Transport håndterer også opbevaring af køretøjer, når det indgår i den konkrete løsning. Mulighederne aftales ud fra opgaven, så forløbet passer til bilens stand og destination."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Fra bjærgning til den videre transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Bjærgning løser den første del, når bilen står fast eller vanskeligt. Derefter kan der være behov for bugsering af bil eller transport på skydelad. Har du et havari på vejen, kan du læse mere om vores autohjælp og vælge den løsning, der passer til situationen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skal et skadet køretøj flyttes over længere afstand, kan opgaven fortsætte som autotransport. Vi transporterer nye, brugte, skadede og brændte biler i hele Danmark. Det gør det muligt at samle bjærgning og den efterfølgende flytning, når den valgte løsning kræver det."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Sådan får du den rette autohjælp"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du kontakter os, hjælper det at beskrive hændelsen så konkret som muligt. Fortæl om bilen holder på vej, mark eller i grøft, og om hjulene kan rulle. Nævn også synlige skader og særlige adgangsforhold. Det giver et bedre grundlag for at vælge udstyr og planlægge hjælpen."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Præcis placering og adgang til køretøjet"
          },
          {
            tag: "li",
            text: "Køretøjets type og aktuelle stand"
          },
          {
            tag: "li",
            text: "Oplysninger om skader og hjul der ikke ruller"
          },
          {
            tag: "li",
            text: "Ønsket destination efter bjærgningen"
          }
        ]
      },
      {
        type: "paragraph",
        tag: "p",
        text: "MC Transport har en vagtcentral, som kan kontaktes døgnet rundt ved behov for akut autohjælp, fritrækning eller bjærgning. Vi løser opgaver i hele Danmark. Har du en akut situation eller vil du aftale en planlagt opgave, kan du kontakte MC Transport og beskrive dit behov."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvornår er bjærgning og redning nødvendig?",
          answer_tag: "p",
          answer: "Bjærgning og redning er relevant, når et køretøj står i en grøft, sidder fast i sne eller mudder eller er så beskadiget, at det ikke kan flyttes normalt. MC Transport vurderer køretøjets placering, stand og adgangsforhold, før opgaven sættes i gang."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på fritrækning og bjærgning af biler?",
          answer_tag: "p",
          answer: "Fritrækning bruges typisk, når en bil skal trækkes tilbage på et stabilt underlag og derefter kan køre videre eller læsses. Bjærgning af biler kan kræve løft, særligt materiel og efterfølgende transport, hvis bilen er svært beskadiget eller står vanskeligt tilgængeligt. MC Transport vælger løsning ud fra de konkrete forhold."
        },
        {
          question_tag: "h4",
          question: "Hvilket bjærgningskøretøj bruges til en fastkørt eller skadet bil?",
          answer_tag: "p",
          answer: "Valget af bjærgningskøretøj afhænger af bilens størrelse, skadernes omfang, underlaget og adgangen til stedet. MC Transport råder blandt andet over skydeladsbiler og kranbiler og vurderer, hvilket materiel der er nødvendigt til den enkelte opgave."
        },
        {
          question_tag: "h4",
          question: "Kan man få akut autohjælp og bjærgning døgnet rundt?",
          answer_tag: "p",
          answer: "Ja, MC Transport har en vagtcentral, som kan kontaktes døgnet rundt ved behov for akut autohjælp, fritrækning eller bjærgning. Virksomheden løser opgaver i hele Danmark."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved behov for bjærgning?",
          answer_tag: "p",
          answer: "Oplys den præcise placering, køretøjets type og stand, synlige skader, om hjulene kan rulle, samt eventuelle særlige adgangsforhold. MC Transport bruger oplysningerne og gerne billeder til at vurdere materiellet og planlægge hjælpen."
        },
        {
          question_tag: "h4",
          question: "Kan en skadet eller brændt bil transporteres efter bjærgning?",
          answer_tag: "p",
          answer: "Ja, efter bjærgning kan MC Transport transportere skadede og brændte biler til den aftalte destination, eksempelvis på skydelad. Virksomheden kan også håndtere opbevaring af køretøjet, når det indgår i den aftalte løsning."
        },
        {
          question_tag: "h4",
          question: "Bør man selv forsøge at trække en fastkørt bil fri?",
          answer_tag: "p",
          answer: "Man bør undgå selv at udføre fritrækning, hvis der er usikkerhed om fæstepunkter, vægt, underlag eller trækretning. En forkert fremgangsmåde kan belaste bilen eller gøre adgangen vanskeligere. MC Transport vurderer underlag, hældning, skader og pladsen omkring bilen før fritrækningen."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvornår er bjærgning og redning nødvendig?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bjærgning og redning er relevant, når et køretøj står i en grøft, sidder fast i sne eller mudder eller er så beskadiget, at det ikke kan flyttes normalt. MC Transport vurderer køretøjets placering, stand og adgangsforhold, før opgaven sættes i gang."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på fritrækning og bjærgning af biler?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Fritrækning bruges typisk, når en bil skal trækkes tilbage på et stabilt underlag og derefter kan køre videre eller læsses. Bjærgning af biler kan kræve løft, særligt materiel og efterfølgende transport, hvis bilen er svært beskadiget eller står vanskeligt tilgængeligt. MC Transport vælger løsning ud fra de konkrete forhold."
          }
        },
        {
          "@type": "Question",
          name: "Hvilket bjærgningskøretøj bruges til en fastkørt eller skadet bil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Valget af bjærgningskøretøj afhænger af bilens størrelse, skadernes omfang, underlaget og adgangen til stedet. MC Transport råder blandt andet over skydeladsbiler og kranbiler og vurderer, hvilket materiel der er nødvendigt til den enkelte opgave."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få akut autohjælp og bjærgning døgnet rundt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, MC Transport har en vagtcentral, som kan kontaktes døgnet rundt ved behov for akut autohjælp, fritrækning eller bjærgning. Virksomheden løser opgaver i hele Danmark."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved behov for bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Oplys den præcise placering, køretøjets type og stand, synlige skader, om hjulene kan rulle, samt eventuelle særlige adgangsforhold. MC Transport bruger oplysningerne og gerne billeder til at vurdere materiellet og planlægge hjælpen."
          }
        },
        {
          "@type": "Question",
          name: "Kan en skadet eller brændt bil transporteres efter bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, efter bjærgning kan MC Transport transportere skadede og brændte biler til den aftalte destination, eksempelvis på skydelad. Virksomheden kan også håndtere opbevaring af køretøjet, når det indgår i den aftalte løsning."
          }
        },
        {
          "@type": "Question",
          name: "Bør man selv forsøge at trække en fastkørt bil fri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Man bør undgå selv at udføre fritrækning, hvis der er usikkerhed om fæstepunkter, vægt, underlag eller trækretning. En forkert fremgangsmåde kan belaste bilen eller gøre adgangen vanskeligere. MC Transport vurderer underlag, hældning, skader og pladsen omkring bilen før fritrækningen."
          }
        }
      ]
    }
  },
  {
    page_id: "37eacce9-110b-4259-b769-080179ad9786",
    url_path: "/tow-truck",
    badge: "International · 24/7 Roadside Assistance",
    heroImage: "/_assets/volvo-bjaergningslastbil-motorvej.jpg",
    seo: {
      title_tag: "Tow Truck & Roadside Assistance | MC Transport",
      meta_description: "Få tow truck i hele Danmark, når bilen eller lastbilen står stille. MC Transport hjælper døgnet rundt med bugsering, bjærgning og sikker transport."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Tow truck og autohjælp når dit køretøj holder stille"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når bilen, varevognen eller lastbilen ikke kan køre videre, hjælper MC Transport med tow truck, autohjælp, bugsering og bjærgning. Vores vagtcentral er åben 24/7, og vi løser opgaver i hele Danmark. Ud fra situationen finder vi en relevant løsning med blandt andet skydeladsbil, kranbil eller bjærgningskøretøj."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Towing service Denmark når du har brug for hjælp på vejen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Towing service Denmark er den engelske betegnelse, som mange bruger, når de har brug for bugsering og transport under en køretur i Danmark. Hos MC Transport håndterer vi både den akutte assistance og den videre transport til værksted, opbevaring eller en anden aftalt adresse."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Begrebet roadside assistance Denmark kan dække flere situationer. Nogle køretøjer skal bugseres fra vejen, mens andre først skal fritrækkes eller bjærges. Læs mere om vores autohjælp. Vi tager højde for køretøjets tilstand og placering, når behovet skal afklares."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Bugsering efter havari eller uheld"
          },
          {
            tag: "li",
            text: "Bjærgning og fritrækning fra grøft, mudder eller sne"
          },
          {
            tag: "li",
            text: "Transport af skadede og brændte biler"
          },
          {
            tag: "li",
            text: "Transport til værksted, opbevaring eller en anden aftalt adresse"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvilken tow truck passer til situationen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En almindelig personbil med havari kræver ikke nødvendigvis samme materiel som en skadet bil i en grøft eller en lastbil, der ikke kan flyttes. Derfor er oplysninger om køretøjstype, vægtklasse, skader og adgangsforhold vigtige, når det rette bjærgningskøretøj skal vælges til opgaven."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Car towing Denmark med kontrolleret læsning"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når internationale bilister søger efter car towing Denmark, er behovet ofte at få en personbil væk efter havari eller skade. Vi transporterer nye, brugte, skadede og brændte biler. En skydeladsbil kan være relevant, når bilen ikke kan eller bør trækkes direkte på vejen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har bilen fået en skade, eller er den brudt sammen, kan transport til værksted eller en anden adresse være den praktiske løsning. På vores side om bugsering af bil kan du læse mere om ydelsen. Ved fastkørsel vurderes først, om bilen skal fritrækkes før transport."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Truck towing Denmark med materiel til opgaven"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Truck towing Denmark beskriver bugsering og bjærgning af lastbiler på danske veje. Lastbilens størrelse, placering og tilstand har stor betydning for valg af materiel. Fortæl derfor, om køretøjet står på vejen, er kørt fast eller er involveret i et uheld."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Bugsering af større køretøjer er en anden type opgave end transport af en personbil, og løsningen må tilpasses det konkrete køretøj. Læs mere om bugsering af lastbil, eller kontakt os, hvis du er i tvivl om, hvilken hjælp situationen kræver."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Vehicle recovery Denmark ved skade og fastkørsel"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Søger du efter vehicle recovery Denmark, kan køretøjet være havnet i en grøft, kørt fast i mudder eller sne eller være så skadet, at almindelig bugsering ikke er relevant. Vores bjærgning handler om at få køretøjet fri eller tilbage på et sted, hvor det kan læsses og transporteres videre."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad skal vi vide når du bestiller autohjælp"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du kontakter vores vagtcentral, er få konkrete oplysninger en stor hjælp. De gør det lettere at forstå, om opgaven handler om vejhjælp, bugsering, bjærgning eller transport. Du behøver ikke selv kende den tekniske løsning, men fortæl gerne det, du kan se på stedet."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Køretøjets type og aktuelle tilstand"
          },
          {
            tag: "li",
            text: "Din placering og de lokale adgangsforhold"
          },
          {
            tag: "li",
            text: "Om køretøjet står på vejen eller uden for kørebanen"
          },
          {
            tag: "li",
            text: "Det ønskede leveringssted og eventuelt behov for opbevaring"
          }
        ]
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Står køretøjet et udsat sted, skal din egen sikkerhed komme først. Søg væk fra trafikken, hvis det kan ske forsvarligt, og følg gældende anvisninger på stedet. Ved personskade eller akut fare skal du kontakte alarmcentralen. Derefter kan du kontakte os om bjærgning og transport."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad koster en tow truck i Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen på en tow truck afhænger blandt andet af køretøjets type, afstanden, placeringen, skadeomfanget og det materiel, som opgaven kræver. En almindelig bugsering kan derfor ikke prissættes på samme måde som fritrækning fra en grøft eller bjærgning af et større køretøj."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for hjælp nu, kan du kontakte vores vagtcentral, som er åben 24/7. Ved en planlagt opgave kan du sende oplysninger om køretøj, afhentningssted og leveringssted via vores kontaktside. Så har vi et bedre grundlag for at vurdere opgaven og give et tilbud."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad omfatter towing service Denmark og roadside assistance Denmark?",
          answer_tag: "p",
          answer: "Hos MC Transport omfatter towing service Denmark og roadside assistance Denmark blandt andet autohjælp, bugsering, bjærgning, fritrækning og videre transport. Vagtcentralen er åben 24/7, og køretøjet kan transporteres til værksted, opbevaring eller en anden aftalt adresse i Danmark."
        },
        {
          question_tag: "h4",
          question: "Hvornår er en tow truck nødvendig?",
          answer_tag: "p",
          answer: "En tow truck kan være nødvendig, når en bil, varevogn eller lastbil ikke kan køre videre efter havari, fastkørsel, skade eller uheld. MC Transport vurderer situationen og vælger en relevant løsning med eksempelvis skydeladsbil, kranbil eller bjærgningskøretøj."
        },
        {
          question_tag: "h4",
          question: "Hvordan foregår car towing Denmark for en skadet bil?",
          answer_tag: "p",
          answer: "Ved car towing Denmark vurderer MC Transport bilens tilstand, placering og adgangsforhold. Nye, brugte, skadede og brændte biler kan læsses kontrolleret på blandt andet en skydeladsbil og transporteres til værksted, opbevaring eller en anden aftalt adresse."
        },
        {
          question_tag: "h4",
          question: "Hvad afgør valget af materiel til truck towing Denmark?",
          answer_tag: "p",
          answer: "Ved truck towing Denmark afhænger valget af materiel af lastbilens størrelse, vægtklasse, placering og aktuelle tilstand. MC Transport tager også højde for, om lastbilen står på vejen, er kørt fast eller har været involveret i et uheld."
        },
        {
          question_tag: "h4",
          question: "Hvad betyder vehicle recovery Denmark ved fastkørsel?",
          answer_tag: "p",
          answer: "Vehicle recovery Denmark dækker blandt andet bjærgning og fritrækning af køretøjer fra grøfter, mudder eller sne. MC Transport får køretøjet fri eller tilbage til et egnet sted, hvor det efter behov kan læsses og transporteres videre."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af autohjælp?",
          answer_tag: "p",
          answer: "MC Transport har brug for oplysninger om køretøjstype, køretøjets tilstand, placering, adgangsforhold og det ønskede leveringssted. Det er også relevant at oplyse, om køretøjet står på vejen eller uden for kørebanen, og om der er behov for opbevaring."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på bugsering og bjærgning?",
          answer_tag: "p",
          answer: "Bugsering bruges typisk, når et køretøj skal flyttes eller transporteres efter havari eller skade. Bjærgning er relevant, når køretøjet først skal fritrækkes fra eksempelvis en grøft, mudder eller sne. MC Transport vurderer, hvilken løsning og hvilket materiel opgaven kræver."
        },
        {
          question_tag: "h4",
          question: "Hvad koster en tow truck i Danmark?",
          answer_tag: "p",
          answer: "Prisen på en tow truck afhænger blandt andet af køretøjstype, afstand, placering, skadeomfang og det nødvendige materiel. MC Transport kan vurdere opgaven og give et tilbud ud fra oplysninger om køretøjet samt afhentnings- og leveringsstedet."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad omfatter towing service Denmark og roadside assistance Denmark?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Hos MC Transport omfatter towing service Denmark og roadside assistance Denmark blandt andet autohjælp, bugsering, bjærgning, fritrækning og videre transport. Vagtcentralen er åben 24/7, og køretøjet kan transporteres til værksted, opbevaring eller en anden aftalt adresse i Danmark."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår er en tow truck nødvendig?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En tow truck kan være nødvendig, når en bil, varevogn eller lastbil ikke kan køre videre efter havari, fastkørsel, skade eller uheld. MC Transport vurderer situationen og vælger en relevant løsning med eksempelvis skydeladsbil, kranbil eller bjærgningskøretøj."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan foregår car towing Denmark for en skadet bil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved car towing Denmark vurderer MC Transport bilens tilstand, placering og adgangsforhold. Nye, brugte, skadede og brændte biler kan læsses kontrolleret på blandt andet en skydeladsbil og transporteres til værksted, opbevaring eller en anden aftalt adresse."
          }
        },
        {
          "@type": "Question",
          name: "Hvad afgør valget af materiel til truck towing Denmark?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved truck towing Denmark afhænger valget af materiel af lastbilens størrelse, vægtklasse, placering og aktuelle tilstand. MC Transport tager også højde for, om lastbilen står på vejen, er kørt fast eller har været involveret i et uheld."
          }
        },
        {
          "@type": "Question",
          name: "Hvad betyder vehicle recovery Denmark ved fastkørsel?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Vehicle recovery Denmark dækker blandt andet bjærgning og fritrækning af køretøjer fra grøfter, mudder eller sne. MC Transport får køretøjet fri eller tilbage til et egnet sted, hvor det efter behov kan læsses og transporteres videre."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af autohjælp?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport har brug for oplysninger om køretøjstype, køretøjets tilstand, placering, adgangsforhold og det ønskede leveringssted. Det er også relevant at oplyse, om køretøjet står på vejen eller uden for kørebanen, og om der er behov for opbevaring."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på bugsering og bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bugsering bruges typisk, når et køretøj skal flyttes eller transporteres efter havari eller skade. Bjærgning er relevant, når køretøjet først skal fritrækkes fra eksempelvis en grøft, mudder eller sne. MC Transport vurderer, hvilken løsning og hvilket materiel opgaven kræver."
          }
        },
        {
          "@type": "Question",
          name: "Hvad koster en tow truck i Danmark?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Prisen på en tow truck afhænger blandt andet af køretøjstype, afstand, placering, skadeomfang og det nødvendige materiel. MC Transport kan vurdere opgaven og give et tilbud ud fra oplysninger om køretøjet samt afhentnings- og leveringsstedet."
          }
        }
      ]
    }
  },
  {
    page_id: "c78e1f27-0b7f-4681-9631-c923a1bb7fe5",
    url_path: "/fritraekning",
    badge: "Terrængående 4x4 · Landsdækkende",
    heroImage: "/_assets/uni-man-4x4-bjaergningskoeretoej.jpg",
    seo: {
      title_tag: "Fritrækning i hele Danmark 24/7 | MC Transport",
      meta_description: "Få hurtig fritrækning af bil eller lastbil i hele Danmark. MC Transport har døgnåben vagtcentral og vælger det rette materiel til en sikker indsats."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Fritrækning og autohjælp når dit køretøj sidder fast"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Sidder din bil eller lastbil fast i en grøft, i mudder eller i sne, hjælper MC Transport med fritrækning i hele Danmark. Vores vagtcentral tager imod akutte henvendelser døgnet rundt. Vi vurderer placeringen, køretøjets stand og behovet for materiel, før opgaven sættes i gang."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår er fritrækning den rigtige hjælp"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fritrækning er relevant, når hjulene har mistet grebet, eller når køretøjet er endt uden for fast underlag. Forsøg på at køre fri kan grave hjulene længere ned og gøre situationen mere vanskelig. Det er derfor ofte bedst at standse og få vurderet, hvordan køretøjet kan trækkes fri."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Før vi går i gang, ser vi på adgangsforhold, terræn og køretøjets placering. En kontrolleret indsats mindsker risikoen for yderligere skade på hjul, undervogn og karrosseri. Metoden afhænger altid af den konkrete situation, da to fastkørsler sjældent er helt ens."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Når grøft, mudder og sne gør opgaven vanskelig"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En bil i en grøft kan stå skævt eller ustabilt, mens et køretøj i mudder kan være sunket ned omkring hjulene. Sne og glatte rabatter giver andre udfordringer. Et bjærgningskøretøj kan være relevant, når køretøjet skal trækkes tilbage til et fast og tilgængeligt underlag."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Bilen er skredet ud og kan ikke komme tilbage på fast underlag."
          },
          {
            tag: "li",
            text: "Køretøjet sidder fast i mudder, blødt terræn eller dyb sne."
          },
          {
            tag: "li",
            text: "En lastbil er kørt fast og kræver en særskilt vurdering af placeringen."
          },
          {
            tag: "li",
            text: "Køretøjet er skadet og skal muligvis videre med autotransport."
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Sådan giver du os det bedste grundlag"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du ringer, må du gerne beskrive stedet så præcist som muligt. Fortæl hvilken type køretøj det drejer sig om, hvordan det står, og om der er synlige skader. De oplysninger gør det lettere at vurdere opgaven og vælge en løsning, der passer til forholdene på stedet."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Din placering og oplysninger om adgangsforholdene."
          },
          {
            tag: "li",
            text: "Køretøjets type, stand og eventuelle synlige skader."
          },
          {
            tag: "li",
            text: "Om køretøjet står på vejen, i en grøft eller på blødt underlag."
          },
          {
            tag: "li",
            text: "Billeder af området, hvis det kan gøres uden at udsætte nogen for fare."
          }
        ]
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Hvis køretøjet står til fare for trafikken, skal du først sørge for at komme i sikkerhed. Kontakt alarmcentralen ved akut fare, og følg anvisninger fra politi eller redningsmandskab. Undgå at opholde dig tæt på trafikken, mens du venter på den videre hjælp."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Fritrækning, bjærgning eller bugsering"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fritrækning handler om at få et fastkørt køretøj tilbage på et underlag, hvor det kan flyttes videre. Bjærgning bruges ofte ved skader eller mere krævende placeringer. Bugsering er den efterfølgende transport, når bilen eller lastbilen ikke selv kan fortsætte."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Du kan læse mere om vores bjærgning og bugsering af bil. Har du brug for anden hjælp efter et havari, finder du flere oplysninger om autohjælp. Vi vurderer, hvilke ydelser der er relevante for din situation."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Fritrækning for bil og lastbil i hele Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "MC Transport løser opgaver i Hedensted og resten af Danmark. Vores vagtcentral tager imod akutte henvendelser døgnet rundt, så du kan beskrive situationen og få afklaret det videre forløb. Den nødvendige indsats afhænger blandt andet af køretøjet og området omkring det."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved fritrækning af en lastbil er placering, underlag og adgangsforhold særligt vigtige. Store køretøjer kræver en grundig vurdering, før arbejdet begynder. Fortæl derfor så meget som muligt om lastbilen og fastkørslen, så behovet for materiel kan vurderes korrekt."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Få hjælp og en pris på den konkrete opgave"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen på fritrækning afhænger af køretøjets type, placeringen, adgangsforholdene og det nødvendige materiel. Det har også betydning, om køretøjet kan køre videre, eller om der efterfølgende er behov for bugsering eller autotransport til et værksted eller en anden adresse."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ring til vores vagtcentral, hvis du har akut brug for fritrækning. Ved øvrige spørgsmål kan du kontakte MC Transport og beskrive opgaven. Oplys gerne placering, køretøjstype og køretøjets stand, så vi har et godt grundlag for at hjælpe dig videre."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad er fritrækning af en bil eller lastbil?",
          answer_tag: "p",
          answer: "Fritrækning bruges til at få et fastkørt køretøj tilbage på et fast underlag, så det kan køre videre eller transporteres væk. MC Transport udfører fritrækning af både biler og lastbiler og vurderer terræn, adgangsforhold og køretøjets placering, før arbejdet sættes i gang."
        },
        {
          question_tag: "h4",
          question: "Skal man selv forsøge at køre et fastkørt køretøj fri?",
          answer_tag: "p",
          answer: "Det er ofte bedst at standse, da gentagne forsøg kan grave hjulene længere ned og øge risikoen for skader på hjul, undervogn og karrosseri. MC Transport vurderer situationen og vælger en kontrolleret metode til fritrækning."
        },
        {
          question_tag: "h4",
          question: "Kan man få hjælp til fritrækning i grøft, mudder eller sne?",
          answer_tag: "p",
          answer: "Ja. MC Transport hjælper, når en bil eller lastbil er skredet i en grøft, sunket ned i mudder, kørt fast i blødt terræn eller ikke kan komme fri af dyb sne. Det nødvendige bjærgningsmateriel vælges ud fra køretøjet, underlaget og adgangsforholdene."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af fritrækning?",
          answer_tag: "p",
          answer: "MC Transport har brug for en præcis placering, oplysninger om adgangsforholdene, køretøjets type og stand samt eventuelle synlige skader. Det er også relevant at oplyse, om køretøjet står på vejen, i en grøft eller på blødt underlag. Billeder kan hjælpe vurderingen, hvis de kan tages uden fare."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på fritrækning, bjærgning og bugsering?",
          answer_tag: "p",
          answer: "Fritrækning får et fastkørt køretøj tilbage på et underlag, hvor det kan flyttes. Bjærgning anvendes ofte ved skader eller mere krævende placeringer, mens bugsering er den efterfølgende transport, hvis køretøjet ikke selv kan fortsætte. MC Transport vurderer, hvilke ydelser der er nødvendige i den konkrete situation."
        },
        {
          question_tag: "h4",
          question: "Kan man få akut autohjælp og fritrækning døgnet rundt?",
          answer_tag: "p",
          answer: "Ja. MC Transports vagtcentral tager imod akutte henvendelser om autohjælp og fritrækning døgnet rundt. Virksomheden løser opgaver i hele Danmark og vurderer placering, køretøj og behovet for materiel, når kunden ringer."
        },
        {
          question_tag: "h4",
          question: "Hvad koster fritrækning af et køretøj?",
          answer_tag: "p",
          answer: "Prisen på fritrækning afhænger blandt andet af køretøjets type, placeringen, adgangsforholdene og det nødvendige materiel. Prisen påvirkes også af, om bilen eller lastbilen efterfølgende skal bugseres eller transporteres til et værksted eller en anden adresse. MC Transport giver en vurdering ud fra den konkrete opgave."
        },
        {
          question_tag: "h4",
          question: "Hvad skal man gøre, hvis et fastkørt køretøj er til fare for trafikken?",
          answer_tag: "p",
          answer: "Kom først i sikkerhed, og undgå at opholde dig tæt på trafikken. Kontakt alarmcentralen ved akut fare, og følg anvisninger fra politi eller redningsmandskab. Når det er sikkert, kan MC Transports vagtcentral kontaktes for at vurdere fritrækning, bjærgning eller bugsering."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad er fritrækning af en bil eller lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Fritrækning bruges til at få et fastkørt køretøj tilbage på et fast underlag, så det kan køre videre eller transporteres væk. MC Transport udfører fritrækning af både biler og lastbiler og vurderer terræn, adgangsforhold og køretøjets placering, før arbejdet sættes i gang."
          }
        },
        {
          "@type": "Question",
          name: "Skal man selv forsøge at køre et fastkørt køretøj fri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Det er ofte bedst at standse, da gentagne forsøg kan grave hjulene længere ned og øge risikoen for skader på hjul, undervogn og karrosseri. MC Transport vurderer situationen og vælger en kontrolleret metode til fritrækning."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få hjælp til fritrækning i grøft, mudder eller sne?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transport hjælper, når en bil eller lastbil er skredet i en grøft, sunket ned i mudder, kørt fast i blødt terræn eller ikke kan komme fri af dyb sne. Det nødvendige bjærgningsmateriel vælges ud fra køretøjet, underlaget og adgangsforholdene."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af fritrækning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport har brug for en præcis placering, oplysninger om adgangsforholdene, køretøjets type og stand samt eventuelle synlige skader. Det er også relevant at oplyse, om køretøjet står på vejen, i en grøft eller på blødt underlag. Billeder kan hjælpe vurderingen, hvis de kan tages uden fare."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på fritrækning, bjærgning og bugsering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Fritrækning får et fastkørt køretøj tilbage på et underlag, hvor det kan flyttes. Bjærgning anvendes ofte ved skader eller mere krævende placeringer, mens bugsering er den efterfølgende transport, hvis køretøjet ikke selv kan fortsætte. MC Transport vurderer, hvilke ydelser der er nødvendige i den konkrete situation."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få akut autohjælp og fritrækning døgnet rundt?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja. MC Transports vagtcentral tager imod akutte henvendelser om autohjælp og fritrækning døgnet rundt. Virksomheden løser opgaver i hele Danmark og vurderer placering, køretøj og behovet for materiel, når kunden ringer."
          }
        },
        {
          "@type": "Question",
          name: "Hvad koster fritrækning af et køretøj?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Prisen på fritrækning afhænger blandt andet af køretøjets type, placeringen, adgangsforholdene og det nødvendige materiel. Prisen påvirkes også af, om bilen eller lastbilen efterfølgende skal bugseres eller transporteres til et værksted eller en anden adresse. MC Transport giver en vurdering ud fra den konkrete opgave."
          }
        },
        {
          "@type": "Question",
          name: "Hvad skal man gøre, hvis et fastkørt køretøj er til fare for trafikken?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Kom først i sikkerhed, og undgå at opholde dig tæt på trafikken. Kontakt alarmcentralen ved akut fare, og følg anvisninger fra politi eller redningsmandskab. Når det er sikkert, kan MC Transports vagtcentral kontaktes for at vurdere fritrækning, bjærgning eller bugsering."
          }
        }
      ]
    }
  },
  {
    page_id: "301f5c71-0f85-4c8d-914a-5e1b3d94b2da",
    url_path: "/skiltevogn",
    badge: "Trafiksikkerhed · Synlig Varsling",
    heroImage: "/_assets/roed-volvo-og-2-lastbiler-18-03-2025-411.jpg",
    seo: {
      title_tag: "Skiltevogn til sikker afmærkning | MC Transport",
      meta_description: "Få en skiltevogn til synlig afmærkning ved autohjælp, bjærgning og transport. MC Transport hjælper ved akutte og planlagte opgaver i hele Danmark. Ring døgnet rundt."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Skiltevogn til synlig afmærkning ved autohjælp og transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En skiltevogn giver tydelig varsling, når et køretøj eller en arbejdsopgave befinder sig tæt på trafikken. Hos MC Transport bruger vi løsningen som en del af afmærkningen ved autohjælp, transport og andre opgaver ved vejen. Vi dækker opgaver i hele Danmark."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår gør en skiltevogn en vigtig forskel?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En skiltevogn er relevant, når en opgave påvirker trafikken, eller når mandskab og materiel står på et udsat sted. Den tidlige varsling hjælper bilister med at opdage situationen og tilpasse kørslen. Det er især vigtigt, når udsynet er begrænset, eller forholdene hurtigt kan ændre sig."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Behovet afhænger blandt andet af vejtypen, placeringen, trafikkens hastighed og opgavens varighed. En opstilling ved en mindre vej kræver ikke nødvendigvis samme løsning som en opgave nær tæt eller hurtig trafik. Derfor tager vi udgangspunkt i den konkrete situation frem for en fast standardløsning."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Klar varsling giver trafikanterne bedre tid til at reagere"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skiltevognen gør opmærksom på, at der foregår arbejde eller holder et køretøj længere fremme. Det giver andre trafikanter bedre mulighed for at sænke farten og passere med større opmærksomhed. Afmærkningen skal samtidig placeres, så den er synlig og passer til vejens forløb."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Ved havari, hvor et køretøj holder udsat nær kørebanen"
          },
          {
            tag: "li",
            text: "Ved autohjælp, bugsering eller bjærgning omkring et havareret køretøj"
          },
          {
            tag: "li",
            text: "Ved aflæsning og pålæsning tæt på passerende trafik"
          },
          {
            tag: "li",
            text: "Ved midlertidige opgaver, hvor trafikanter skal varsles i god tid"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Sådan planlægger vi afmærkningen omkring opgaven"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vi ser på hele arbejdsområdet, før vi vurderer behovet for en skiltevogn. Det handler både om, hvor transportmateriellet skal holde, hvordan køretøjet kan nås, og hvor trafikanterne kommer fra. Skiltevognen indgår dermed som en del af opgaven og ikke som en tilfældig placering ved vejen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved autohjælp eller bjærgning kan forholdene ændre sig undervejs. Et køretøj kan eksempelvis stå tættere på kørebanen end først antaget, eller læsningen kan kræve mere arbejdsplads. Du kan læse mere om vores autohjælp og bjærgning."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Hvad er forskellen på en skiltevogn og en TMA løsning?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En skiltevogn bruges først og fremmest til tydelig varsling og visuel trafikafmærkning. En TMA løsning har en anden rolle og fungerer som fysisk beskyttelse ved særligt udsatte opgaver. Du kan læse mere om vores TMA løsning, hvis opgaven kræver denne type sikring."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du kontakter os, hjælper det, at vi får konkrete oplysninger om stedet og opgaven. Så kan vi bedre danne os et overblik over adgangsforholdene, trafikken og det materiel, der skal bruges. Placering og afmærkning skal altid tilpasses forholdene og eventuelle anvisninger på stedet."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Den præcise placering og den aktuelle vejtype"
          },
          {
            tag: "li",
            text: "Hvilket køretøj eller materiel opgaven omfatter"
          },
          {
            tag: "li",
            text: "Om opgaven er akut eller planlagt"
          },
          {
            tag: "li",
            text: "Særlige forhold ved adgang, udsyn eller passerende trafik"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Har du brug for en skiltevogn i hele Danmark?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "MC Transport løser både akutte og planlagte opgaver i hele Danmark. En skiltevogn kan indgå ved autohjælp, transport, bugsering og andre situationer, hvor der er behov for synlig afmærkning. Vi tager udgangspunkt i opgaven, så løsningen passer til stedet og det arbejde, der skal udføres."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for en skiltevogn til en planlagt eller akut opgave, kan du kontakte os med oplysninger om sted og situation. Ved akutte hændelser kan vores vagtcentral kontaktes døgnet rundt. Brug vores kontaktside for at starte dialogen, så ser vi på den relevante løsning."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad bruges en skiltevogn til?",
          answer_tag: "p",
          answer: "En skiltevogn bruges til synlig varsling og trafikafmærkning, når et køretøj, mandskab eller materiel befinder sig tæt på trafikken. Hos MC Transport kan skiltevognen indgå ved blandt andet autohjælp, transport, bugsering og bjærgning."
        },
        {
          question_tag: "h4",
          question: "Hvornår er der behov for en skiltevogn ved vejarbejde eller autohjælp?",
          answer_tag: "p",
          answer: "En skiltevogn kan være relevant, når en opgave påvirker trafikken, eller når mandskab og materiel står udsat nær kørebanen. MC Transport vurderer behovet ud fra blandt andet vejtypen, placeringen, trafikkens hastighed, udsynet og opgavens varighed."
        },
        {
          question_tag: "h4",
          question: "Kan en skiltevogn bruges ved bugsering og bjærgning?",
          answer_tag: "p",
          answer: "Ja, en skiltevogn kan bruges til tydelig afmærkning ved bugsering og bjærgning af et havareret køretøj. Hos MC Transport tilpasses afmærkningen den konkrete situation, så trafikanterne varsles om køretøjet og arbejdsområdet."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på en skiltevogn og en TMA-løsning?",
          answer_tag: "p",
          answer: "En skiltevogn bruges primært til synlig varsling og visuel trafikafmærkning. En TMA-løsning har en anden funktion og anvendes som fysisk beskyttelse ved særligt udsatte opgaver. MC Transport vurderer løsningen ud fra opgavens placering og forholdene på stedet."
        },
        {
          question_tag: "h4",
          question: "Hvordan placeres en skiltevogn ved en opgave?",
          answer_tag: "p",
          answer: "Placeringen skal give trafikanterne mulighed for at opdage situationen i god tid og tilpasse kørslen. MC Transport ser derfor på vejens forløb, udsyn, adgangsforhold, trafikretning og placeringen af transportmateriellet samt eventuelle anvisninger på stedet."
        },
        {
          question_tag: "h4",
          question: "Kan man bestille en skiltevogn til både akutte og planlagte opgaver?",
          answer_tag: "p",
          answer: "Ja, MC Transport løser både akutte og planlagte opgaver med skiltevogn i hele Danmark. Ved akutte hændelser kan virksomhedens vagtcentral kontaktes døgnet rundt."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af en skiltevogn?",
          answer_tag: "p",
          answer: "Det er relevant at oplyse den præcise placering, vejtypen, hvilket køretøj eller materiel opgaven omfatter, og om opgaven er akut eller planlagt. MC Transport kan også bruge oplysninger om adgang, udsyn og passerende trafik til at vurdere den relevante løsning."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad bruges en skiltevogn til?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En skiltevogn bruges til synlig varsling og trafikafmærkning, når et køretøj, mandskab eller materiel befinder sig tæt på trafikken. Hos MC Transport kan skiltevognen indgå ved blandt andet autohjælp, transport, bugsering og bjærgning."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår er der behov for en skiltevogn ved vejarbejde eller autohjælp?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En skiltevogn kan være relevant, når en opgave påvirker trafikken, eller når mandskab og materiel står udsat nær kørebanen. MC Transport vurderer behovet ud fra blandt andet vejtypen, placeringen, trafikkens hastighed, udsynet og opgavens varighed."
          }
        },
        {
          "@type": "Question",
          name: "Kan en skiltevogn bruges ved bugsering og bjærgning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, en skiltevogn kan bruges til tydelig afmærkning ved bugsering og bjærgning af et havareret køretøj. Hos MC Transport tilpasses afmærkningen den konkrete situation, så trafikanterne varsles om køretøjet og arbejdsområdet."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på en skiltevogn og en TMA-løsning?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En skiltevogn bruges primært til synlig varsling og visuel trafikafmærkning. En TMA-løsning har en anden funktion og anvendes som fysisk beskyttelse ved særligt udsatte opgaver. MC Transport vurderer løsningen ud fra opgavens placering og forholdene på stedet."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan placeres en skiltevogn ved en opgave?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Placeringen skal give trafikanterne mulighed for at opdage situationen i god tid og tilpasse kørslen. MC Transport ser derfor på vejens forløb, udsyn, adgangsforhold, trafikretning og placeringen af transportmateriellet samt eventuelle anvisninger på stedet."
          }
        },
        {
          "@type": "Question",
          name: "Kan man bestille en skiltevogn til både akutte og planlagte opgaver?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, MC Transport løser både akutte og planlagte opgaver med skiltevogn i hele Danmark. Ved akutte hændelser kan virksomhedens vagtcentral kontaktes døgnet rundt."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af en skiltevogn?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Det er relevant at oplyse den præcise placering, vejtypen, hvilket køretøj eller materiel opgaven omfatter, og om opgaven er akut eller planlagt. MC Transport kan også bruge oplysninger om adgang, udsyn og passerende trafik til at vurdere den relevante løsning."
          }
        }
      ]
    }
  },
  {
    page_id: "942a23c5-4c61-4c83-8cb7-68465dde2c1b",
    url_path: "/TMA",
    badge: "Påkørselssikring · Vejarbejde",
    heroImage: "/_assets/roed-volvo-med-militaer-udstyr-18-03-2025-224.jpg",
    seo: {
      title_tag: "TMA køretøj til tryggere vejarbejde | MC Transport",
      meta_description: "Få et TMA køretøj, der hjælper med at skabe en tydelig og beskyttet arbejdszone ved vejarbejde. MC Transport tilbyder TMA kørsel i hele Danmark, få et tilbud."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "TMA køretøj til beskyttelse ved vejarbejde"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skal der udføres arbejde på eller ved en trafikeret vej, kan et TMA køretøj skabe en tydelig og beskyttet arbejdszone. MC Transport tilbyder TMA kørsel til opgaver, hvor trafikken skal ledes sikkert forbi medarbejdere, køretøjer og materiel. Vi løser planlagte opgaver i hele Danmark."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvorfor gør et TMA køretøj en vigtig forskel?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "TMA er en forkortelse for Truck Mounted Attenuator. Det er en energiabsorberende stødpude, som er monteret bag på et køretøj. Formålet er at dæmpe kraften ved en eventuel påkørsel bagfra og dermed give ekstra beskyttelse mellem den øvrige trafik og arbejdet på vejen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et TMA køretøj bruges ofte ved vejarbejde, vedligeholdelse, afmærkning og andre opgaver, hvor mennesker eller materiel befinder sig tæt på kørende trafik. Løsningen er især relevant, når arbejdsområdet er midlertidigt, eller når det ændrer placering i takt med, at arbejdet skrider frem."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Når arbejdsstedet flytter sig undervejs"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved mobile opgaver skal sikringen kunne følge arbejdsstedet. Her kan TMA kørsel være en praktisk løsning, fordi køretøjet flyttes sammen med opgaven. Det kan være relevant ved arbejde langs vejbanen, ved kortvarige stop eller ved opgaver, hvor en fast afspærring ikke dækker hele forløbet."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Den rigtige placering afhænger ikke kun af selve arbejdsområdet. Vejens forløb, trafikmængden, hastigheden og udsynet har også betydning. Derfor bør en TMA opgave altid planlægges ud fra de faktiske forhold og den afmærkningsplan, der gælder for arbejdet."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad skal TMA opgaven tilpasses efter?"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ikke to arbejdssteder er ens. Før en TMA bil sættes ind, skal rammerne for opgaven være tydelige. Det gør det lettere at vælge en hensigtsmæssig placering og koordinere kørslen med øvrige køretøjer, medarbejdere og materiel på stedet. Følgende forhold er særligt relevante."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Vejtypen, den tilladte hastighed og trafikkens retning omkring arbejdsområdet"
          },
          {
            tag: "li",
            text: "Om arbejdet foregår på samme sted eller bevæger sig langs vejbanen"
          },
          {
            tag: "li",
            text: "Placeringen af medarbejdere, maskiner og øvrige køretøjer under arbejdet"
          },
          {
            tag: "li",
            text: "Adgangsforholdene samt den gældende plan for afmærkning og trafikafvikling"
          }
        ]
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En præcis beskrivelse giver et bedre grundlag for at vurdere opgaven. Hvis forholdene ændrer sig undervejs, bør placering og arbejdsgang justeres efter den gældende plan. TMA køretøjet er et vigtigt led i sikringen, men det skal indgå korrekt i den samlede afmærkning."
      },
      {
        type: "heading",
        tag: "h3",
        text: "God planlægning begynder med de rigtige oplysninger"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du kontakter os, er det en fordel at oplyse adressen, tidspunktet, vejtypen og arbejdets forventede varighed. Fortæl også, om opgaven står stille eller flytter sig. Har du en afmærkningsplan eller særlige krav til placeringen, kan de oplysninger indgå i vores vurdering."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vi kan herefter afklare, hvordan transport og TMA kørsel kan indgå i opgaven. Ved at få de vigtigste detaljer på plads fra start mindsker vi risikoen for misforståelser på arbejdsstedet og skaber et mere overskueligt forløb for både dig, vores chauffør og de øvrige aktører."
      },
      {
        type: "heading",
        tag: "h2",
        text: "TMA og skiltevogn giver tydeligere varsling"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved mange opgaver er det ikke nok at beskytte arbejdsområdet. Trafikanterne skal også have tydelig besked i god tid. En skiltevogn kan bruges til synlig varsling og information, mens TMA køretøjet fungerer som fysisk beskyttelse nærmere arbejdszonen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Om der er behov for begge løsninger, afhænger af opgaven og den gældende afmærkning. Vi planlægger vores del af indsatsen ud fra de oplysninger, du giver os, så TMA køretøj og skiltevogn kan indgå i det aftalte forløb på arbejdsstedet."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Bestil TMA kørsel i hele Danmark"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for et TMA køretøj til en planlagt opgave, er du velkommen til at tage fat i MC Transport. Vi løser transportopgaver i hele Danmark og vurderer TMA kørsel ud fra sted, tidspunkt og arbejdsforhold. Kontakt os med oplysninger om opgaven, så vi kan tale om behovet og give et tilbud."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad er et TMA køretøj?",
          answer_tag: "p",
          answer: "Et TMA køretøj er et køretøj med en energiabsorberende stødpude monteret bagpå. TMA står for Truck Mounted Attenuator. MC Transport tilbyder TMA kørsel, hvor køretøjet indgår som beskyttelse mellem trafikken og arbejdsområdet."
        },
        {
          question_tag: "h4",
          question: "Hvornår bruges en TMA bil ved vejarbejde?",
          answer_tag: "p",
          answer: "En TMA bil bruges typisk ved vejarbejde, vedligeholdelse, afmærkning og andre opgaver, hvor medarbejdere, køretøjer eller materiel befinder sig tæt på kørende trafik. MC Transport løser planlagte TMA-opgaver ud fra forholdene på arbejdsstedet."
        },
        {
          question_tag: "h4",
          question: "Hvordan beskytter et TMA køretøj arbejdszonen?",
          answer_tag: "p",
          answer: "Den energiabsorberende stødpude er beregnet til at dæmpe kraften ved en eventuel påkørsel bagfra. TMA køretøjet skaber dermed ekstra beskyttelse mellem den øvrige trafik og arbejdszonen, når det placeres korrekt som en del af den samlede afmærkning."
        },
        {
          question_tag: "h4",
          question: "Kan TMA kørsel bruges ved mobile vejarbejder?",
          answer_tag: "p",
          answer: "Ja, TMA kørsel kan være relevant ved mobile opgaver, fordi køretøjet kan flyttes sammen med arbejdsstedet. MC Transport kan blandt andet indgå ved arbejde langs vejbanen, kortvarige stop og forløb, hvor en fast afspærring ikke dækker hele opgaven."
        },
        {
          question_tag: "h4",
          question: "Hvad skal placeringen af et TMA køretøj tilpasses efter?",
          answer_tag: "p",
          answer: "Placeringen skal blandt andet tilpasses vejtypen, hastigheden, trafikkens retning, udsynet og trafikmængden. Der skal også tages hensyn til medarbejdere, maskiner, øvrige køretøjer, adgangsforhold og den gældende afmærkningsplan. MC Transport vurderer sin del af opgaven ud fra de oplyste forhold."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man give ved bestilling af TMA kørsel?",
          answer_tag: "p",
          answer: "Det er en fordel at oplyse adressen, tidspunktet, vejtypen, arbejdets forventede varighed og om arbejdsstedet står stille eller flytter sig. En afmærkningsplan og eventuelle krav til placeringen hjælper MC Transport med at vurdere opgaven og koordinere TMA kørslen."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på et TMA køretøj og en skiltevogn?",
          answer_tag: "p",
          answer: "En skiltevogn bruges til synlig varsling og information til trafikanterne, mens et TMA køretøj fungerer som fysisk beskyttelse nærmere arbejdszonen. Om opgaven kræver begge løsninger, afhænger af arbejdsforholdene og den gældende afmærkning. MC Transport kan planlægge TMA køretøj og skiltevogn som dele af det aftalte forløb."
        },
        {
          question_tag: "h4",
          question: "Kan man bestille TMA kørsel i hele Danmark?",
          answer_tag: "p",
          answer: "Ja, MC Transport tilbyder TMA kørsel til planlagte opgaver i hele Danmark. Behovet vurderes ud fra arbejdsstedet, tidspunktet, vejtypen og de konkrete arbejdsforhold, hvorefter virksomheden kan give et tilbud på opgaven."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad er et TMA køretøj?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Et TMA køretøj er et køretøj med en energiabsorberende stødpude monteret bagpå. TMA står for Truck Mounted Attenuator. MC Transport tilbyder TMA kørsel, hvor køretøjet indgår som beskyttelse mellem trafikken og arbejdsområdet."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår bruges en TMA bil ved vejarbejde?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En TMA bil bruges typisk ved vejarbejde, vedligeholdelse, afmærkning og andre opgaver, hvor medarbejdere, køretøjer eller materiel befinder sig tæt på kørende trafik. MC Transport løser planlagte TMA-opgaver ud fra forholdene på arbejdsstedet."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan beskytter et TMA køretøj arbejdszonen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Den energiabsorberende stødpude er beregnet til at dæmpe kraften ved en eventuel påkørsel bagfra. TMA køretøjet skaber dermed ekstra beskyttelse mellem den øvrige trafik og arbejdszonen, når det placeres korrekt som en del af den samlede afmærkning."
          }
        },
        {
          "@type": "Question",
          name: "Kan TMA kørsel bruges ved mobile vejarbejder?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, TMA kørsel kan være relevant ved mobile opgaver, fordi køretøjet kan flyttes sammen med arbejdsstedet. MC Transport kan blandt andet indgå ved arbejde langs vejbanen, kortvarige stop og forløb, hvor en fast afspærring ikke dækker hele opgaven."
          }
        },
        {
          "@type": "Question",
          name: "Hvad skal placeringen af et TMA køretøj tilpasses efter?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Placeringen skal blandt andet tilpasses vejtypen, hastigheden, trafikkens retning, udsynet og trafikmængden. Der skal også tages hensyn til medarbejdere, maskiner, øvrige køretøjer, adgangsforhold og den gældende afmærkningsplan. MC Transport vurderer sin del af opgaven ud fra de oplyste forhold."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man give ved bestilling af TMA kørsel?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Det er en fordel at oplyse adressen, tidspunktet, vejtypen, arbejdets forventede varighed og om arbejdsstedet står stille eller flytter sig. En afmærkningsplan og eventuelle krav til placeringen hjælper MC Transport med at vurdere opgaven og koordinere TMA kørslen."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på et TMA køretøj og en skiltevogn?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En skiltevogn bruges til synlig varsling og information til trafikanterne, mens et TMA køretøj fungerer som fysisk beskyttelse nærmere arbejdszonen. Om opgaven kræver begge løsninger, afhænger af arbejdsforholdene og den gældende afmærkning. MC Transport kan planlægge TMA køretøj og skiltevogn som dele af det aftalte forløb."
          }
        },
        {
          "@type": "Question",
          name: "Kan man bestille TMA kørsel i hele Danmark?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, MC Transport tilbyder TMA kørsel til planlagte opgaver i hele Danmark. Behovet vurderes ud fra arbejdsstedet, tidspunktet, vejtypen og de konkrete arbejdsforhold, hvorefter virksomheden kan give et tilbud på opgaven."
          }
        }
      ]
    }
  },
  {
    page_id: "a61089b4-0f3f-4be2-8838-418d1d82314a",
    url_path: "/daekcenter-lastbil",
    badge: "Dækservice til erhverv · Ugerløse & Mobil service",
    heroImage: "/_assets/service-vogn-1-198.jpg",
    seo: {
      title_tag: "Dækcenter til lastbil | Få styr på dækkene | MC Transport",
      meta_description: "MC Transports dækcenter til lastbil hjælper med kontrol og dækskift tilpasset køretøjet. Få en konkret vurdering, så du kan komme sikkert videre."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Dækcenter til lastbil, få styr på dækkene"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Hos MC Transport får du hjælp på vores dækcenter til lastbil, når slid, skade eller tryktab kræver handling. Vi hjælper med dækskift og tager udgangspunkt i køretøjet og den konkrete situation. Så får du en løsning, der passer til lastbilens brug, dækkets dimension og behovet for at komme sikkert videre."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Et dækcenter for lastbil skal forstå køretøjets opgave"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Dækkene har betydning for vejgreb, stabilitet og sikker kørsel. På en lastbil varierer belastningen mellem akslerne, og derfor skal dækkets placering, dimension og tilstand vurderes samlet. Et dækskift bør ikke kun handle om at montere et nyt dæk, men om at vælge den rigtige løsning til køretøjet."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ujævnt slid, synlige skader og tilbagevendende tryktab kan være tegn på, at dækket skal undersøges nærmere. Kør ikke videre, hvis dækket ikke virker forsvarligt. En tung lastbil stiller store krav til dækkene, og selv mindre skader kan udvikle sig, når køretøjet kører med last over længere afstande."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Jo mere vi ved om lastbilen, desto bedre kan vi afklare, hvilken dækservice der er relevant. Hav gerne de vigtigste oplysninger klar, når du kontakter os om dækskift. Det gør dialogen mere præcis og hjælper os med at danne et tydeligt billede af køretøjet, dækket og situationen."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Lastbilens registreringsnummer og dækkets dimension"
          },
          {
            tag: "li",
            text: "Hvilken aksel og hjulposition problemet gælder"
          },
          {
            tag: "li",
            text: "Antallet af dæk, der skal kontrolleres eller skiftes"
          },
          {
            tag: "li",
            text: "Køretøjets placering og om det kan køre forsvarligt"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår bør lastbilens dæk kontrolleres"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Vent ikke med at reagere, til dækket er helt fladt. Revner, buler, snit, vibrationer og mærkbart tryktab bør tages alvorligt. Det samme gælder slid, som er tydeligt kraftigere på den ene side. En kontrol i tide kan afklare, om der er behov for et dækskift, før problemet giver driftsstop."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Se efter de tegn, der let bliver overset"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et hurtigt blik på dækket før kørsel kan afsløre skader, men se også på mønsteret og dæksiden. Sten og andre genstande kan sidde i mønsteret, mens skader på siden kan være svære at vurdere uden faglig hjælp. Er du i tvivl, er det sikrest at få dækket undersøgt."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Synlige revner, snit eller buler i dæksiden"
          },
          {
            tag: "li",
            text: "Ujævnt slid på tværs af dækkets mønster"
          },
          {
            tag: "li",
            text: "Vibrationer eller ændret kørsel under belastning"
          },
          {
            tag: "li",
            text: "Tryk, der falder igen efter påfyldning"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad påvirker prisen på dækskift til lastbil"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En pris på dækskift til lastbil afhænger af den konkrete opgave. Dækkets størrelse, antallet af dæk og køretøjets placering er relevante oplysninger. Der er også forskel på et egentligt dækskifte, hvor dækket tages af fælgen, og et hjulskift, hvor det samlede hjul udskiftes."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Fortæl os, hvilken lastbil det gælder, og hvad du har observeret. Så kan vi tage stilling til opgaven på et bedre grundlag. Hvis du vil læse mere om selve ydelsen, kan du gå til vores side om dækskift til lastbil eller kontakte os for en konkret vurdering."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Når dækskaden stopper lastbilen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Hvis et beskadiget dæk betyder, at lastbilen ikke kan fortsætte forsvarligt, skal køretøjet stå så sikkert som muligt. MC Transport har en 24/7 vagtcentral til akutte behov. Her kan situationen afklares, så der kan tages stilling til autohjælp, bjærgning eller anden relevant assistance."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Du kan læse mere om vores autohjælp og bugsering af lastbil. Bugsering er relevant, når køretøjet ikke kan bringes videre på egne hjul og skal transporteres til et egnet sted. Den konkrete løsning afhænger af lastbilens tilstand, placering og adgangsforhold."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Få en konkret vurdering hos MC Transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du brug for et dækcenter til lastbil eller vil du planlægge et dækskift, er du velkommen til at kontakte MC Transport. Oplys gerne registreringsnummer, dækdimension, antal dæk og køretøjets placering. Så har vi et godt udgangspunkt for at tale om den rette hjælp."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvad hjælper et dækcenter til lastbil med?",
          answer_tag: "p",
          answer: "Et dækcenter til lastbil hjælper med at undersøge dækkenes tilstand og vurdere behovet for dækskift. Hos MC Transport tager vurderingen udgangspunkt i lastbilens anvendelse, dækkets dimension, hjulpositionen og den konkrete skade eller slitage."
        },
        {
          question_tag: "h4",
          question: "Hvornår bør lastbilens dæk kontrolleres eller skiftes?",
          answer_tag: "p",
          answer: "Lastbilens dæk bør kontrolleres ved revner, snit, buler, ujævnt slid, vibrationer eller tilbagevendende tryktab. MC Transport anbefaler, at dækket undersøges, før problemet udvikler sig til et driftsstop. Lastbilen bør ikke køre videre, hvis dækket ikke virker forsvarligt."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man have klar ved dækskift til lastbil?",
          answer_tag: "p",
          answer: "Ved dækskift til lastbil er det relevant at oplyse registreringsnummer, dækdimension, aksel og hjulposition samt antallet af dæk, der skal kontrolleres eller skiftes. MC Transport skal også gerne kende køretøjets placering, og om lastbilen kan køre forsvarligt."
        },
        {
          question_tag: "h4",
          question: "Hvad påvirker prisen på dækskift til lastbil?",
          answer_tag: "p",
          answer: "Prisen på dækskift til lastbil afhænger blandt andet af dækkets størrelse, antallet af dæk, køretøjets placering og opgavens karakter. MC Transport foretager en konkret vurdering ud fra oplysningerne om lastbilen og det observerede problem."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på dækskift og hjulskift på en lastbil?",
          answer_tag: "p",
          answer: "Ved et dækskift tages dækket af fælgen og erstattes, mens et hjulskift betyder, at det samlede hjul udskiftes. MC Transport vurderer den relevante løsning ud fra dækkets og køretøjets tilstand."
        },
        {
          question_tag: "h4",
          question: "Hvad skal man gøre, hvis en dækskade stopper lastbilen?",
          answer_tag: "p",
          answer: "Hvis lastbilen ikke kan fortsætte forsvarligt, skal den placeres så sikkert som muligt. MC Transport har en 24/7-vagtcentral, som kan afklare behovet for autohjælp, bjærgning eller anden relevant assistance ud fra køretøjets tilstand og placering."
        },
        {
          question_tag: "h4",
          question: "Hvornår er bugsering af lastbil nødvendig efter en dækskade?",
          answer_tag: "p",
          answer: "Bugsering af lastbil kan være nødvendig, når en dækskade betyder, at køretøjet ikke kan bringes videre på egne hjul. MC Transport vurderer løsningen ud fra lastbilens tilstand, placering og adgangsforhold og kan transportere køretøjet til et egnet sted."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvad hjælper et dækcenter til lastbil med?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Et dækcenter til lastbil hjælper med at undersøge dækkenes tilstand og vurdere behovet for dækskift. Hos MC Transport tager vurderingen udgangspunkt i lastbilens anvendelse, dækkets dimension, hjulpositionen og den konkrete skade eller slitage."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår bør lastbilens dæk kontrolleres eller skiftes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Lastbilens dæk bør kontrolleres ved revner, snit, buler, ujævnt slid, vibrationer eller tilbagevendende tryktab. MC Transport anbefaler, at dækket undersøges, før problemet udvikler sig til et driftsstop. Lastbilen bør ikke køre videre, hvis dækket ikke virker forsvarligt."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man have klar ved dækskift til lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved dækskift til lastbil er det relevant at oplyse registreringsnummer, dækdimension, aksel og hjulposition samt antallet af dæk, der skal kontrolleres eller skiftes. MC Transport skal også gerne kende køretøjets placering, og om lastbilen kan køre forsvarligt."
          }
        },
        {
          "@type": "Question",
          name: "Hvad påvirker prisen på dækskift til lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Prisen på dækskift til lastbil afhænger blandt andet af dækkets størrelse, antallet af dæk, køretøjets placering og opgavens karakter. MC Transport foretager en konkret vurdering ud fra oplysningerne om lastbilen og det observerede problem."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på dækskift og hjulskift på en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved et dækskift tages dækket af fælgen og erstattes, mens et hjulskift betyder, at det samlede hjul udskiftes. MC Transport vurderer den relevante løsning ud fra dækkets og køretøjets tilstand."
          }
        },
        {
          "@type": "Question",
          name: "Hvad skal man gøre, hvis en dækskade stopper lastbilen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Hvis lastbilen ikke kan fortsætte forsvarligt, skal den placeres så sikkert som muligt. MC Transport har en 24/7-vagtcentral, som kan afklare behovet for autohjælp, bjærgning eller anden relevant assistance ud fra køretøjets tilstand og placering."
          }
        },
        {
          "@type": "Question",
          name: "Hvornår er bugsering af lastbil nødvendig efter en dækskade?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Bugsering af lastbil kan være nødvendig, når en dækskade betyder, at køretøjet ikke kan bringes videre på egne hjul. MC Transport vurderer løsningen ud fra lastbilens tilstand, placering og adgangsforhold og kan transportere køretøjet til et egnet sted."
          }
        }
      ]
    }
  },
  {
    page_id: "cdb99bfc-5aa9-4c4d-be4b-f4a6e2d93a48",
    url_path: "/daekskift-lastbil",
    badge: "Akut & Planlagt dækservice · Døgnvagt 24/7",
    heroImage: "/_assets/servicevogn-3-206.jpg",
    seo: {
      title_tag: "Dækskift til lastbil, kom hurtigt videre | MC Transport",
      meta_description: "Få dækskift til lastbil hos MC Transport og hjælp til både planlagte skift og akutte dækskader. Kontakt vagtcentralen døgnet rundt i hele Danmark."
    },
    content: [
      {
        type: "heading",
        tag: "h1",
        text: "Dækskift til lastbil, når driften skal videre"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et dækskift på en lastbil skal passe til både køretøjet, dækdimensionen og den konkrete drift. Hos MC Transport hjælper vi med dækskift til lastbil, så du får afklaret opgaven og kan komme videre. Vi løser opgaver for erhverv i hele Danmark."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvornår bør du få et dækskifte på lastbilen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et dækskifte bliver aktuelt, når dækket er slidt, beskadiget eller ikke længere passer til kørslen og årstiden. På en lastbil bør du også reagere på ujævnt slid, revner, gentagne tryktab og ændret kørsel. En tidlig vurdering kan mindske risikoen for driftsstop."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Lastbildæk arbejder under høj belastning. Derfor skal tilstand, lufttryk og dæktype vurderes i forhold til køretøjets brug. Det gælder både trækkere, forvogne og trailere. Er du i tvivl, kan vi hjælpe med at afklare, om opgaven kræver dækskift eller anden assistance."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Slidbanen er ujævn eller tydeligt slidt på dele af dækket"
          },
          {
            tag: "li",
            text: "Dækket har revner, buler, snit eller andre synlige skader"
          },
          {
            tag: "li",
            text: "Lufttrykket falder gentagne gange uden en tydelig forklaring"
          },
          {
            tag: "li",
            text: "Lastbilen ændrer køreegenskaber eller giver usædvanlige vibrationer"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Dækskift og hjulskift, kender du forskellen"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Et dækskift betyder normalt, at selve dækket afmonteres fra fælgen og erstattes. Ved et hjulskift udskiftes det komplette hjul med dæk og fælg. Forskellen har betydning for opgavens omfang, så fortæl os gerne, hvad der allerede sidder på køretøjet."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved dækskift på en lastbil skal dimension, placering og belastning passe sammen. Dækket på en styreaksel har ikke nødvendigvis samme funktion som dækket på en trækaksel eller trailer. Derfor tager vurderingen udgangspunkt i den konkrete lastbil og dens anvendelse."
      },
      {
        type: "heading",
        tag: "h3",
        text: "De rette oplysninger gør dækskiftet lettere at planlægge"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Når du kontakter MC Transport, er registreringsnummer, dækdimension og akselplacering gode oplysninger at have klar. Fortæl også, om lastbilen holder på en sikker plads, og om den er læsset. Det gør det lettere at vurdere materiel, adgangsforhold og næste skridt."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Har du behov for planlagt dækservice, kan du læse mere om vores dækcenter til lastbil. Her får du overblik over service omkring lastbildæk og mulighed for at kontakte os om opgaven. Det giver et godt grundlag for planlægningen."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Punktering på vejen, hvad gør du nu"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "En punktering eller dækskade kan standse hele kørslen. Sørg først for at placere køretøjet så sikkert som muligt. Oplys derefter din præcise position, køretøjets type og skadens placering. Så kan vi vurdere, hvilken hjælp der passer til situationen."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Ved akut behov kan du kontakte vores vagtcentral 24 timer i døgnet. Det gælder den akutte assistance, mens et planlagt dækskift aftales særskilt. Du kan også læse om vores autohjælp til lastbil, hvis problemet kræver mere end service på dækket."
      },
      {
        type: "heading",
        tag: "h3",
        text: "Når lastbilen ikke kan køre videre"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Kan lastbilen ikke bringes videre efter dækskaden, kan transport være den rette løsning. MC Transport arbejder også med bugsering af lastbil og bjærgning. Vi vurderer opgaven ud fra køretøjets tilstand og placering, så indsatsen kan planlægges."
      },
      {
        type: "heading",
        tag: "h2",
        text: "Hvad koster et dækskift til lastbil"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Prisen på dækskift afhænger af flere forhold. Dækdimension, antal dæk, køretøjets placering og behovet for akut assistance kan påvirke opgaven. Derfor oplyser vi ikke en fast pris, som måske ikke passer til netop din lastbil eller den aktuelle situation."
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Send de vigtigste oplysninger fra starten, hvis du ønsker et tilbud på dækskifte. Jo mere præcis beskrivelsen er, desto bedre kan vi afklare behovet. Billeder af skaden og dækkets mærkning kan også være nyttige, når det er muligt at tage dem sikkert."
      },
      {
        type: "list",
        tag: "ul",
        items: [
          {
            tag: "li",
            text: "Registreringsnummer og type af lastbil eller trailer"
          },
          {
            tag: "li",
            text: "Dækdimension og placering på køretøjet"
          },
          {
            tag: "li",
            text: "Antal dæk og en kort beskrivelse af problemet"
          },
          {
            tag: "li",
            text: "Adresse eller præcis position samt adgangsforhold"
          }
        ]
      },
      {
        type: "heading",
        tag: "h2",
        text: "Få afklaret dit dækskift hos MC Transport"
      },
      {
        type: "paragraph",
        tag: "p",
        text: "Skal dækkene på din lastbil skiftes, eller står du med en punktering, hjælper vi dig med at finde næste skridt. MC Transport håndterer både planlagte opgaver og akut assistance i hele Danmark. Kontakt os med oplysninger om lastbilen og opgaven."
      }
    ],
    faq: {
      display_on_page: true,
      section_heading: {
        tag: "h3",
        text: "Ofte stillede spørgsmål"
      },
      items: [
        {
          question_tag: "h4",
          question: "Hvornår bør man få foretaget dækskift på en lastbil?",
          answer_tag: "p",
          answer: "Et dækskift på en lastbil bør overvejes, når dækket er slidt, beskadiget eller ikke passer til kørslen og årstiden. Ujævnt slid, revner, buler, snit, gentagne tryktab, vibrationer eller ændrede køreegenskaber bør undersøges. MC Transport hjælper med at vurdere behovet for dækskift eller anden assistance."
        },
        {
          question_tag: "h4",
          question: "Hvad er forskellen på dækskift og hjulskift på en lastbil?",
          answer_tag: "p",
          answer: "Ved et dækskift afmonteres selve dækket fra fælgen og erstattes, mens et hjulskift omfatter udskiftning af det komplette hjul med både dæk og fælg. Forskellen påvirker opgavens omfang, og MC Transport vurderer løsningen ud fra lastbilen, dækdimensionen og det eksisterende udstyr."
        },
        {
          question_tag: "h4",
          question: "Hvordan vælger man det rette lastbildæk til den enkelte aksel?",
          answer_tag: "p",
          answer: "Dækdimension, belastning, køretøjets anvendelse og dækkets placering skal passe sammen. Dæk på en styreaksel har ikke nødvendigvis samme funktion som dæk på en trækaksel eller trailer. MC Transport tager derfor udgangspunkt i den konkrete lastbil og dens drift, når opgaven skal afklares."
        },
        {
          question_tag: "h4",
          question: "Hvilke oplysninger skal man have klar ved bestilling af dækskift til lastbil?",
          answer_tag: "p",
          answer: "Det er en fordel at oplyse registreringsnummer, køretøjstype, dækdimension, akselplacering, antal dæk og en beskrivelse af problemet. MC Transport bør også have den præcise position, adgangsforholdene og information om, hvorvidt lastbilen er læsset. Billeder af skaden og dækkets mærkning kan desuden være nyttige."
        },
        {
          question_tag: "h4",
          question: "Hvad skal man gøre ved en punktering på en lastbil?",
          answer_tag: "p",
          answer: "Ved en punktering eller dækskade skal lastbilen først placeres så sikkert som muligt. Oplys derefter den præcise position, køretøjstype og skadens placering. MC Transport kan på den baggrund vurdere, om der er behov for hjælp til dækket, autohjælp, bugsering eller bjærgning."
        },
        {
          question_tag: "h4",
          question: "Kan man få akut hjælp ved dækskade på en lastbil hele døgnet?",
          answer_tag: "p",
          answer: "MC Transport har en vagtcentral, som kan kontaktes 24 timer i døgnet ved behov for akut assistance. Den konkrete hjælp vurderes ud fra lastbilens tilstand, placering og dækskaden. Planlagt dækskift og dækservice aftales særskilt."
        },
        {
          question_tag: "h4",
          question: "Hvad koster et dækskift på en lastbil?",
          answer_tag: "p",
          answer: "Prisen på dækskift til lastbil afhænger blandt andet af dækdimensionen, antallet af dæk, køretøjstypen, placeringen, adgangsforholdene og behovet for akut assistance. MC Transport giver derfor en konkret vurdering ud fra oplysningerne om lastbilen og opgaven."
        },
        {
          question_tag: "h4",
          question: "Hvad sker der, hvis lastbilen ikke kan køre videre efter en dækskade?",
          answer_tag: "p",
          answer: "Hvis lastbilen ikke kan bringes videre efter en dækskade, kan bugsering, bjærgning eller transport være nødvendigt. MC Transport vurderer løsningen ud fra køretøjets tilstand og placering og kan håndtere opgaver i hele Danmark."
        }
      ]
    },
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hvornår bør man få foretaget dækskift på en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Et dækskift på en lastbil bør overvejes, når dækket er slidt, beskadiget eller ikke passer til kørslen og årstiden. Ujævnt slid, revner, buler, snit, gentagne tryktab, vibrationer eller ændrede køreegenskaber bør undersøges. MC Transport hjælper med at vurdere behovet for dækskift eller anden assistance."
          }
        },
        {
          "@type": "Question",
          name: "Hvad er forskellen på dækskift og hjulskift på en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved et dækskift afmonteres selve dækket fra fælgen og erstattes, mens et hjulskift omfatter udskiftning af det komplette hjul med både dæk og fælg. Forskellen påvirker opgavens omfang, og MC Transport vurderer løsningen ud fra lastbilen, dækdimensionen og det eksisterende udstyr."
          }
        },
        {
          "@type": "Question",
          name: "Hvordan vælger man det rette lastbildæk til den enkelte aksel?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Dækdimension, belastning, køretøjets anvendelse og dækkets placering skal passe sammen. Dæk på en styreaksel har ikke nødvendigvis samme funktion som dæk på en trækaksel eller trailer. MC Transport tager derfor udgangspunkt i den konkrete lastbil og dens drift, når opgaven skal afklares."
          }
        },
        {
          "@type": "Question",
          name: "Hvilke oplysninger skal man have klar ved bestilling af dækskift til lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Det er en fordel at oplyse registreringsnummer, køretøjstype, dækdimension, akselplacering, antal dæk og en beskrivelse af problemet. MC Transport bør også have den præcise position, adgangsforholdene og information om, hvorvidt lastbilen er læsset. Billeder af skaden og dækkets mærkning kan desuden være nyttige."
          }
        },
        {
          "@type": "Question",
          name: "Hvad skal man gøre ved en punktering på en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ved en punktering eller dækskade skal lastbilen først placeres så sikkert som muligt. Oplys derefter den præcise position, køretøjstype og skadens placering. MC Transport kan på den baggrund vurdere, om der er behov for hjælp til dækket, autohjælp, bugsering eller bjærgning."
          }
        },
        {
          "@type": "Question",
          name: "Kan man få akut hjælp ved dækskade på en lastbil hele døgnet?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "MC Transport har en vagtcentral, som kan kontaktes 24 timer i døgnet ved behov for akut assistance. Den konkrete hjælp vurderes ud fra lastbilens tilstand, placering og dækskaden. Planlagt dækskift og dækservice aftales særskilt."
          }
        },
        {
          "@type": "Question",
          name: "Hvad koster et dækskift på en lastbil?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Prisen på dækskift til lastbil afhænger blandt andet af dækdimensionen, antallet af dæk, køretøjstypen, placeringen, adgangsforholdene og behovet for akut assistance. MC Transport giver derfor en konkret vurdering ud fra oplysningerne om lastbilen og opgaven."
          }
        },
        {
          "@type": "Question",
          name: "Hvad sker der, hvis lastbilen ikke kan køre videre efter en dækskade?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Hvis lastbilen ikke kan bringes videre efter en dækskade, kan bugsering, bjærgning eller transport være nødvendigt. MC Transport vurderer løsningen ud fra køretøjets tilstand og placering og kan håndtere opgaver i hele Danmark."
          }
        }
      ]
    }
  }
];

// Helper to find page by exact or normalized path
export function getSeoPageByPath(pathname) {
  const clean = String(pathname || '').trim().toLowerCase().replace(/\/+$/, '');
  const decoded = decodeURIComponent(clean);
  return SEO_PAGES_DATA.find((p) => {
    const pPath = p.url_path.toLowerCase().replace(/\/+$/, '');
    if (pPath === clean || pPath === decoded) return true;
    if (clean === '/daekcenter-lastbil' && (pPath === '/dækcenter lastbil' || pPath === '/daekcenter-lastbil')) return true;
    if (clean === '/daekskift-lastbil' && (pPath === '/dækskift lastbil' || pPath === '/daekskift-lastbil')) return true;
    return false;
  });
}
